export const postalCodes = {
    1000: "Lausanne",
    1001: "Lausanne",
    1002: "Lausanne",
    1003: "Lausanne",
    1004: "Lausanne",
    1005: "Lausanne",
    1006: "Lausanne",
    1007: "Lausanne",
    1008: "Jouxtens-Mézery - Prilly",
    1009: "Pully",
    1010: "Lausanne",
    1011: "Lausanne",
    1012: "Lausanne",
    1014: "Lausanne",
    1015: "Lausanne",
    1017: "Lausanne",
    1018: "Lausanne",
    1019: "Lausanne",
    1020: "Renens",
    1022: "Chavannes-près-Renens",
    1023: "Crissier",
    1024: "Ecublens",
    1025: "St-Sulpice",
    1026: "Echandens - Denges",
    1027: "Lonay",
    1028: "Préverenges",
    1029: "Villars-Ste-Croix",
    1030: "Bussigny-près-Lausanne",
    1031: "Mex",
    1032: "Romanel-sur-Lausanne",
    1033: "Cheseaux-sur-Lausanne",
    1034: "Boussens",
    1035: "Bournens",
    1036: "Sullens",
    1037: "Etagnières",
    1038: "Bercher",
    1039: "Cheseaux Polyval",
    1040: "Echallens - St-Barthélemy - Villars-le-Terroir",
    1041: "Poliez-le-Grand - Bottens - Poliez-Pittet - Naz - Dommartin - Montaubion-Chardonney",
    1042: "Bioley-Orjulaz - Bettens - Assens",
    1043: "Sugnens",
    1044: "Fey",
    1045: "Ogens",
    1046: "Rueyres",
    1047: "Oppens",
    1052: "Le Mont-sur-Lausanne",
    1053: "Cugy - Bretigny-sur-Morrens",
    1054: "Morrens",
    1055: "Froideville",
    1058: "Villars-Tiercelin",
    1059: "Peney-le-Jorat",
    1061: "Villars-Mendraz",
    1062: "Sottens",
    1063: "Martherenges - Chapelle-sur-Moudon - Boulens - Peyres-Possens",
    1066: "Epalinges",
    1068: "Les Monts-de-Pully",
    1070: "Puidoux",
    1071: "Rivaz - St-Saphorin (Lavaux) - Chexbres",
    1072: "Forel (Lavaux)",
    1073: "Savigny - Mollie-Margot",
    1076: "Ferlens",
    1077: "Servion",
    1078: "Essertes",
    1080: "Les Cullayes",
    1081: "Montpreveyres",
    1082: "Corcelles-le-Jorat",
    1083: "Mézières",
    1084: "Carrouge",
    1085: "Vulliens",
    1088: "Ropraz",
    1090: "La Croix (Lutry)",
    1091: "Chenaux - Grandvaux - Aran",
    1092: "Belmont-sur-Lausanne",
    1093: "La Conversion",
    1094: "Paudex",
    1095: "Lutry",
    1096: "Villette (Lavaux) - Cully",
    1097: "Riex",
    1098: "Epesses",
    1110: "Morges",
    1112: "Echichens",
    1113: "St-Saphorin-sur-Morges",
    1114: "Colombier",
    1115: "Vullierens",
    1116: "Cottens",
    1117: "Grancy",
    1121: "Bremblens",
    1122: "Romanel-sur-Morges",
    1123: "Aclens",
    1124: "Gollion",
    1125: "Monnaz",
    1126: "Vaux-sur-Morges",
    1127: "Clarmont",
    1128: "Reverolle",
    1131: "Tolochenaz",
    1132: "Lully",
    1134: "Vufflens-le-Château - Chigny",
    1135: "Denens",
    1136: "Bussy-Chardonney",
    1141: "Sévery",
    1142: "Pampigny",
    1143: "Apples",
    1144: "Ballens",
    1145: "Bière",
    1146: "Mollens",
    1147: "Montricher",
    1148: "La Praz - Chavannes-le-Veyron - Villars-Bozon - La Coudre - Cuarnens - Moiry - Mont-la-Ville - Mauraz - L'Isle",
    1149: "Berolle",
    1162: "St-Prex",
    1163: "Etoy",
    1164: "Buchillon",
    1165: "Allaman",
    1166: "Perroy",
    1167: "Lussy-sur-Morges",
    1168: "Villars-sous-Yens",
    1169: "Yens",
    1170: "Aubonne",
    1172: "Bougy-Villars",
    1173: "Féchy",
    1174: "Montherod - Pizy",
    1175: "Lavigny",
    1176: "St-Livres",
    1180: "Tartegnin - Rolle",
    1182: "Gilly",
    1183: "Bursins",
    1184: "Luins - Vinzel",
    1185: "Mont-sur-Rolle",
    1186: "Essertines-sur-Rolle",
    1187: "St-Oyens",
    1188: "Gimel - St-George",
    1189: "Saubraz",
    1195: "Bursinel - Dully",
    1196: "Gland",
    1197: "Prangins",
    1200: "Genève",
    1201: "Genève",
    1202: "Genève",
    1203: "Genève",
    1204: "Genève",
    1205: "Genève",
    1206: "Genève",
    1207: "Genève",
    1208: "Genève",
    1209: "Genève",
    1211: "Genève",
    1212: "Grand-Lancy",
    1213: "Onex - Petit-Lancy",
    1214: "Vernier",
    1215: "Genève",
    1216: "Cointrin",
    1217: "Meyrin",
    1218: "Le Grand-Saconnex",
    1219: "Châtelaine - Le Lignon - Aïre",
    1220: "Les Avanchets",
    1222: "Vésenaz",
    1223: "Cologny",
    1224: "Chêne-Bougeries",
    1225: "Chêne-Bourg",
    1226: "Thônex",
    1227: "Les Acacias - Carouge",
    1228: "Plan-les-Ouates",
    1231: "Conches",
    1232: "Confignon",
    1233: "Bernex",
    1234: "Vessy",
    1236: "Cartigny",
    1237: "Avully",
    1239: "Collex",
    1240: "Genève",
    1241: "Puplinge",
    1242: "Satigny",
    1243: "Presinge",
    1244: "Choulex",
    1245: "Collonge-Bellerive",
    1246: "Corsier",
    1247: "Anières",
    1248: "Hermance",
    1251: "Gy",
    1252: "Meinier",
    1253: "Vandoeuvres",
    1254: "Jussy",
    1255: "Veyrier",
    1256: "Troinex",
    1257: "La Croix-de-Rozon",
    1258: "Perly",
    1260: "Nyon",
    1261: "Longirod - Le Vaud - Marchissy",
    1262: "Eysins",
    1263: "Crassier",
    1264: "St-Cergue",
    1265: "La Cure",
    1266: "Duillier",
    1267: "Vich - Coinsins",
    1268: "Burtigny - Begnins",
    1269: "Bassins",
    1270: "Trélex",
    1271: "Givrins",
    1272: "Genolier",
    1273: "Le Muids - Arzier",
    1274: "Grens - Signy",
    1275: "Chéserex",
    1276: "Gingins",
    1277: "Borex - Arnex-sur-Nyon",
    1278: "La Rippe",
    1279: "Chavannes-de-Bogis - Bogis-Bossey",
    1281: "Russin",
    1283: "Dardagny - La Plaine",
    1284: "Chancy",
    1285: "Athenaz (Avusy)",
    1286: "Soral",
    1287: "Laconnex",
    1288: "Aire-la-Ville",
    1289: "Genève",
    1290: "Versoix - Chavannes-des-Bois",
    1291: "Commugny",
    1292: "Chambésy",
    1293: "Bellevue",
    1294: "Genthod",
    1295: "Mies - Tannay",
    1296: "Coppet",
    1297: "Founex",
    1298: "Céligny",
    1299: "Crans-près-Céligny",
    1300: "Eclépens",
    1302: "Vufflens-la-Ville",
    1303: "Penthaz",
    1304: "Dizy - Senarclens - Allens - Cossonay-Ville",
    1305: "Penthalaz",
    1306: "Daillens",
    1307: "Lussery-Villars",
    1308: "La Chaux (Cossonay)",
    1310: "Daillens",
    1311: "Eclépens",
    1312: "Eclépens",
    1313: "Ferreyres",
    1315: "La Sarraz",
    1316: "Chevilly",
    1317: "Orny",
    1318: "Pompaples",
    1320: "Daillens",
    1321: "Arnex-sur-Orbe",
    1322: "Croy",
    1323: "Romainmôtier",
    1324: "Premier",
    1325: "Vaulion",
    1326: "Juriens",
    1329: "Bretonnières",
    1330: "Daillens",
    1337: "Vallorbe",
    1338: "Ballaigues",
    1341: "Orient",
    1342: "Le Pont",
    1343: "Les Charbonnières",
    1344: "L'Abbaye",
    1345: "Le Lieu",
    1346: "Les Bioux",
    1347: "Le Sentier - Le Solliat",
    1348: "Le Brassus",
    1350: "Orbe",
    1352: "Agiez",
    1353: "Bofflens",
    1354: "Montcherand",
    1355: "Sergey - L'Abergement",
    1356: "La Russille - Les Clées",
    1357: "Lignerolle",
    1358: "Valeyres-sous-Rances",
    1372: "Bavois",
    1373: "Chavornay",
    1374: "Corcelles-sur-Chavornay",
    1375: "Penthéréaz",
    1376: "Eclagnens - Goumoens-la-Ville - Goumoens-le-Jux",
    1377: "Oulens-sous-Echallens",
    1400: "Yverdon-les-Bains - Cheseaux-Noréaz",
    1401: "Yverdon-les-Bains",
    1404: "Cuarny - Villars-Epeney",
    1405: "Pomy",
    1406: "Cronay",
    1407: "Donneloye - Gossens - Mézery-près-Donneloye - Bioley-Magnoux",
    1408: "Prahins",
    1409: "Chanéaz",
    1410: "Prévondavaux - Thierrens - St-Cierges - Correvon - Denezy",
    1412: "Ursins - Valeyres-sous-Ursins",
    1413: "Orzens",
    1415: "Molondin - Démoret",
    1416: "Pailly",
    1417: "Epautheyres - Essertines-sur-Yverdon",
    1418: "Vuarrens",
    1420: "Fiez",
    1421: "Grandevent - Fontaines-sur-Grandson",
    1422: "Grandson",
    1423: "Vaugondry - Fontanezier - Romairon - Villars-Burquin",
    1424: "Champagne",
    1425: "Onnens",
    1426: "Concise - Corcelles-près-Concise",
    1427: "Bonvillars",
    1428: "Provence - Mutrux",
    1429: "Giez",
    1430: "Orges",
    1431: "Novalles - Vugelles-La Mothe",
    1432: "Gressy - Belmont-sur-Yverdon",
    1433: "Suchy",
    1434: "Ependes",
    1435: "Essert-Pittet",
    1436: "Treycovagnes - Chamblon",
    1437: "Suscévaz",
    1438: "Mathod",
    1439: "Rances",
    1440: "Montagny-Chamard",
    1441: "Valeyres-sous-Montagny",
    1442: "Montagny-près-Yverdon",
    1443: "Essert-sous-Champvent - Champvent - Villars-sous-Champvent",
    1445: "Vuiteboeuf",
    1446: "Baulmes",
    1450: "Le Château-de-Ste-Croix - La Sagne (Ste-Croix) - Ste-Croix",
    1452: "Les Rasses",
    1453: "Mauborget - Bullet",
    1454: "L'Auberson - La Vraconnaz",
    1462: "Yvonand",
    1463: "Rovray",
    1464: "Chavannes-le-Chêne - Chêne-Pâquier",
    1468: "Cheyres",
    1470: "Seiry - Bollion - Lully - Estavayer-le-Lac",
    1473: "Font - Châtillon",
    1474: "Châbles",
    1475: "Autavaux - Montbrelloz - Forel",
    1482: "Cugy",
    1483: "Frasses - Montet (Broye) - Vesin",
    1484: "Granges-de-Vesin - Aumont",
    1485: "Nuvilly",
    1486: "Vuissens",
    1489: "Murist",
    1509: "Vucherens",
    1510: "Syens - Moudon",
    1512: "Chavannes-sur-Moudon",
    1513: "Hermenches - Rossenges",
    1514: "Bussy-sur-Moudon",
    1515: "Villars-le-Comte - Neyruz-sur-Moudon",
    1521: "Curtilles",
    1522: "Oulens-sur-Lucens - Lucens",
    1523: "Granges-près-Marnand",
    1524: "Marnand",
    1525: "Seigneux - Henniez",
    1526: "Forel-sur-Lucens - Cremin",
    1527: "Villeneuve",
    1528: "Surpierre - Praratoud",
    1529: "Cheiry",
    1530: "Payerne",
    1532: "Fétigny",
    1533: "Ménières",
    1534: "Chapelle (Broye) - Sassel",
    1535: "Combremont-le-Grand",
    1536: "Combremont-le-Petit",
    1537: "Champtauroz",
    1538: "Treytorrens (Payerne)",
    1541: "Sévaz - Morens - Bussy",
    1542: "Rueyres-les-Prés",
    1543: "Grandcour",
    1544: "Gletterens",
    1545: "Chevroux",
    1551: "Vers-chez-Perrin",
    1552: "Trey",
    1553: "Châtonnaye",
    1554: "Sédeilles - Rossens",
    1555: "Villarzel",
    1562: "Corcelles-près-Payerne",
    1563: "Dompierre",
    1564: "Domdidier",
    1565: "Vallon - Missy",
    1566: "St-Aubin - Les Friques",
    1567: "Delley",
    1568: "Portalban",
    1580: "Avenches - Oleyres",
    1582: "Donatyre",
    1583: "Villarepos",
    1584: "Villars-le-Grand",
    1585: "Salavaux - Cotterd - Bellerive",
    1586: "Vallamand",
    1587: "Constantine - Montmagny",
    1588: "Cudrefin",
    1589: "Chabrey",
    1595: "Clavaleyres - Faoug",
    1607: "Les Tavernes - Palézieux-Village - Les Thioleyres - Palézieux",
    1608: "Chapelle (Glâne) - Bussigny-sur-Oron - Chesalles-sur-Oron - Oron-le-Châtel",
    1609: "Besencens - Fiaugères - St-Martin",
    1610: "Vuibroye - Châtillens - Oron-la-Ville",
    1611: "Le Crêt-près-Semsales",
    1612: "Ecoteaux",
    1613: "Maracon",
    1614: "Granges (Veveyse)",
    1615: "Bossonnens",
    1616: "Attalens",
    1617: "Remaufens - Tatroz",
    1618: "Châtel-St-Denis",
    1619: "Les Paccots",
    1623: "Semsales",
    1624: "Grattavache - La Verrerie - Progens",
    1625: "Sâles (Gruyère) - Maules",
    1626: "Romanens - Treyfayes - Rueyres-Treyfayes",
    1627: "Vaulruz",
    1628: "Vuadens",
    1630: "Bulle",
    1631: "Bulle",
    1632: "Riaz",
    1633: "Vuippens - Marsens",
    1634: "La Roche",
    1635: "La Tour-de-Trême",
    1636: "Broc",
    1637: "Charmey (Gruyère)",
    1638: "Morlon",
    1642: "Sorens",
    1643: "Gumefens",
    1644: "Avry-devant-Pont",
    1645: "Le Bry",
    1646: "Echarlens",
    1647: "Corbières",
    1648: "Hauteville",
    1649: "Pont-la-Ville",
    1651: "Villarvolard",
    1652: "Villarbeney - Botterens",
    1653: "Châtel-sur-Montsalvens - Crésuz",
    1654: "Cerniat",
    1656: "Jaun - Im Fang",
    1657: "Abländschen",
    1658: "La Tine - Rossinière",
    1659: "Flendruz - Rougemont",
    1660: "La Lécherette - Château-d'Oex - Les Moulins - L'Etivaz",
    1661: "Le Pâquier-Montbarry",
    1663: "Moléson-sur-Gruyères - Epagny - Pringy - Gruyères",
    1665: "Estavannens",
    1666: "Villars-sous-Mont - Grandvillard",
    1667: "Enney",
    1669: "Albeuve - Neirivue - Les Sciernes-d'Albeuve - Montbovon - Lessoc",
    1670: "Ursy - Bionnens - Esmonts",
    1673: "Rue - Promasens - Auboranges - Gillarens - Ecublens",
    1674: "Montet (Glâne) - Morlens - Vuarmarens",
    1675: "Mossel - Blessens - Vauderens",
    1676: "Chavannes-les-Forts",
    1677: "Prez-vers-Siviriez",
    1678: "Siviriez",
    1679: "Villaraboud",
    1680: "Romont - Berlens",
    1681: "Billens - Hennens",
    1682: "Prévonloup - Dompierre - Lovatens - Villars-Bramard - Cerniaz",
    1683: "Brenles - Sarzens - Chesalles-sur-Moudon",
    1684: "Mézières",
    1685: "Villariaz",
    1686: "Grangettes-près-Romont - La Neirigue",
    1687: "Vuisternens-devant-Romont - Estévenens - La Magne",
    1688: "Lieffrens - Sommentier",
    1689: "Le Châtelard-près-Romont",
    1690: "Lussy - Villaz-St-Pierre",
    1691: "Villarimboud",
    1692: "Massonnens",
    1694: "Villargiroud - Orsonnens - Chavannes-sous-Orsonnens - Villarsiviriaux",
    1695: "Villarsel-le-Gibloux - Villarlod - Estavayer-le-Gibloux - Rueyres-St-Laurent",
    1696: "Vuisternens-en-Ogoz",
    1697: "La Joux - Les Ecasseys",
    1699: "Pont (Veveyse) - Bouloz - Porsel",
    1700: "Fribourg",
    1701: "Fribourg",
    1702: "Fribourg",
    1704: "Fribourg",
    1705: "Fribourg",
    1707: "Fribourg",
    1708: "Fribourg",
    1709: "Fribourg",
    1712: "Tafers",
    1713: "St. Antoni",
    1714: "Heitenried",
    1715: "Alterswil",
    1716: "Schwarzsee - Plaffeien - Oberschrot",
    1717: "St. Ursen",
    1718: "Rechthalten",
    1719: "Brünisried - Zumholz",
    1720: "Corminboeuf - Chésopelloz",
    1721: "Cournillens - Courtion - Cormérod - Misery",
    1722: "Bourguillon",
    1723: "Marly - Pierrafortscha - Villarsel-sur-Marly",
    1724: "Senèdes - Zénauva - Montévraz - Bonnefontaine - Le Mouret - Oberried - Essert - Ferpicloz",
    1725: "Posieux",
    1726: "Grenilles - Farvagny-le-Petit - Posat - Farvagny",
    1727: "Magnedens - Corpataux-Magnedens",
    1728: "Rossens",
    1730: "Ecuvillens",
    1731: "Ependes",
    1732: "Arconciel",
    1733: "Treyvaux",
    1734: "Tentlingen",
    1735: "Giffers",
    1736: "St. Silvester",
    1737: "Plasselb",
    1738: "Sangernboden",
    1740: "Neyruz",
    1741: "Cottens",
    1742: "Autigny",
    1744: "Chénens",
    1745: "Lentigny",
    1746: "Prez-vers-Noréaz",
    1747: "Corserey",
    1748: "Torny-le-Grand",
    1749: "Middes",
    1752: "Villars-sur-Glâne",
    1753: "Matran",
    1754: "Rosé - Avry-sur-Matran - Avry-Centre - Corjolens",
    1756: "Onnens - Lovens",
    1757: "Noréaz",
    1762: "Givisiez",
    1763: "Granges-Paccot",
    1772: "Ponthaux - Grolley - Nierlet-les-Bois",
    1773: "Russy - Chandon - Léchelles",
    1774: "Cousset - Montagny-les-Monts",
    1775: "Mannens - Grandsivaz",
    1776: "Montagny-la-Ville",
    1782: "La Corbaz - Lossy - Belfaux - Autafond - Cormagens - Formangueires",
    1783: "Barberêche - Pensier",
    1784: "Courtepin - Wallenried - Cournillens",
    1785: "Cressier",
    1786: "Sugiez",
    1787: "Môtier (Vully) - Mur (Vully)",
    1788: "Praz (Vully)",
    1789: "Lugnorre",
    1791: "Courtaman",
    1792: "Guschelmuth - Cordast",
    1793: "Jeuss",
    1794: "Salvenach",
    1795: "Courlevon",
    1796: "Courgevaux",
    1797: "Münchenwiler",
    1800: "Vevey",
    1801: "Le Mont-Pèlerin",
    1802: "Corseaux",
    1803: "Chardonne",
    1804: "Corsier-sur-Vevey",
    1805: "Jongny",
    1806: "St-Légier-La Chiésaz",
    1807: "Blonay",
    1808: "Les Monts-de-Corsier",
    1809: "Fenil-sur-Corsier",
    1811: "Vevey",
    1814: "La Tour-de-Peilz",
    1815: "Clarens",
    1816: "Chailly-Montreux",
    1817: "Brent",
    1818: "Montreux Redoute",
    1820: "Territet - Veytaux - Montreux",
    1822: "Chernex",
    1823: "Glion",
    1824: "Caux",
    1832: "Villard-sur-Chamby - Chamby",
    1833: "Les Avants",
    1844: "Villeneuve",
    1845: "Noville",
    1846: "Chessel",
    1847: "Rennaz",
    1852: "Roche",
    1853: "Yvorne",
    1854: "Leysin",
    1856: "Corbeyrier",
    1860: "Aigle",
    1862: "La Comballaz - Les Mosses",
    1863: "Le Sépey",
    1864: "Vers-l'Eglise",
    1865: "Les Diablerets",
    1866: "La Forclaz",
    1867: "St-Triphon - Panex - Ollon",
    1868: "Collombey",
    1869: "Massongex",
    1870: "Monthey",
    1871: "Les Giettes - Choëx",
    1872: "Troistorrents",
    1873: "Val-d'Illiez - Les Crosets - Champoussin",
    1874: "Champéry",
    1875: "Morgins",
    1880: "Frenières-sur-Bex - Fenalet-sur-Bex - Les Plans-sur-Bex - Les Posses-sur-Bex - Bex",
    1882: "Gryon - Les Posses-sur-Bex",
    1884: "Villars-sur-Ollon - Arveyes - Huémoz",
    1885: "Chesières",
    1890: "Mex - St-Maurice",
    1891: "Vérossaz",
    1892: "Morcles - Lavey-les-Bains - Lavey-Village",
    1893: "Muraz (Collombey)",
    1895: "Vionnaz",
    1896: "Miex - Vouvry",
    1897: "Les Evouettes - Bouveret",
    1898: "St-Gingolph",
    1899: "Torgon",
    1902: "Evionnaz",
    1903: "Collonges",
    1904: "Vernayaz",
    1905: "Dorénaz",
    1906: "Charrat",
    1907: "Saxon",
    1908: "Riddes",
    1911: "Mayens-de-Chamoson - Ovronnaz",
    1912: "Leytron - Dugny (Leytron) - Montagnon (Leytron) - Produit (Leytron)",
    1913: "Saillon",
    1914: "Isérables - Auddes-sur-Riddes",
    1918: "La Tzoumaz",
    1920: "Martigny",
    1921: "Martigny-Croix",
    1922: "Les Granges (Salvan) - Salvan",
    1923: "Les Marécottes - Le Trétien",
    1925: "Le Châtelard - Finhaut",
    1926: "Fully",
    1927: "Chemin",
    1928: "Ravoire",
    1929: "Trient",
    1932: "Les Valettes (Bovernier) - Martigny-Croix",
    1933: "Chamoille (Sembrancher) - La Garde (Sembrancher) - Vens (Sembrancher) - Sembrancher",
    1934: "Fontenelle (Le Châble) - Le Châble - Bruson - Montagnier (Le Châble) - Villette (Le Châble) - Cotterg (Le Châble)",
    1936: "Verbier",
    1937: "Orsières",
    1938: "Champex-Lac",
    1941: "Vollèges - Cries (Vollèges)",
    1942: "Levron",
    1943: "Praz-de-Fort",
    1944: "La Fouly",
    1945: "Rive Haute (Liddes) - Palasuit (Liddes) - Dranse (Liddes) - Les Moulins (Liddes) - Liddes - Vichères (Liddes) - Fontaine Dessous (Liddes) - Fontaine Dessus (Liddes) - Chez Petit (Liddes) - Petit Vichères (Liddes) - Fornex (Liddes) - Chandonne (Liddes)",
    1946: "Bourg-St-Pierre",
    1947: "Les Places (Versegères) - Versegères - Prarreyer (Versegères) - Le Fregnoley (Versegères) - La Montoz (Versegères) - Champsec (Versegères)",
    1948: "Le Planchamp (Lourtier) - Le Morgnes (Lourtier) - Fionnay - Lourtier - Sarreyer",
    1950: "Sion",
    1951: "Sion",
    1955: "Némiaz (Chamoson) - Grugnay (Chamoson) - St-Pierre-de-Clages - Les Vérines (Chamoson) - Chamoson",
    1957: "Ardon",
    1958: "St-Léonard - Uvrier",
    1961: "Vernamiège",
    1962: "Pont-de-la-Morge (Sion)",
    1963: "Vétroz",
    1964: "Conthey",
    1965: "Savièse - Roumaz (Savièse) - Drône - Mayens-de-la-Zour (Savièse) - St-Germain (Savièse) - Chandolin-près-Savièse - Monteiller-Savièse - Granois (Savièse) - Ormône (Savièse)",
    1966: "St-Romain (Ayent) - Blignou (Ayent) - Villa (Ayent) - Argnou (Ayent) - Signèse (Ayent) - La Place (Ayent) - Botyre (Ayent) - Saxonne (Ayent) - Luc (Ayent) - Fortunau (Ayent)",
    1967: "Bramois",
    1968: "Mase",
    1969: "Eison (St.Martin) - St-Martin - Suen (St-Martin) - Liez (St-Martin) - Trogne (St-Martin)",
    1971: "Grimisuat - Champlan (Grimisuat)",
    1972: "Anzère",
    1973: "Nax",
    1974: "Arbaz",
    1975: "St-Séverin",
    1976: "Daillon - Aven - Erde",
    1977: "Icogne",
    1978: "Lens",
    1981: "Vex",
    1982: "Euseigne",
    1983: "Lana (Evolène) - Evolène",
    1984: "Les Haudères - La Tour",
    1985: "La Forclaz - La Sage - Villaz",
    1986: "Arolla",
    1987: "Hérémence",
    1988: "Les Collons - Thyon",
    1991: "Turin (Salins) - Arvillard (Salins) - Pravidondaz (Salins) - Misériez (Salins) - Salins",
    1992: "Crête-à-l'Oeil (Les Agettes) - Les Mayens-de-Sion - La Vernaz (Les Agettes) - Les Agettes",
    1993: "Clèbes (Nendaz) - Veysonnaz",
    1994: "Aproz (Nendaz)",
    1996: "Condémines (Nendaz) - Brignon (Nendaz) - Fey (Nendaz) - Bieudron (Nendaz) - Basse-Nendaz - Baar (Nendaz) - Beuson (Nendaz) - Saclentse",
    1997: "Siviez (Nendaz) - Haute-Nendaz - Sornard (Nendaz)",
    2000: "Neuchâtel",
    2001: "Neuchâtel 1",
    2002: "Neuchâtel 2",
    2003: "Neuchâtel 3",
    2004: "Neuchâtel 4",
    2006: "Neuchâtel 6",
    2007: "Neuchâtel 7",
    2008: "Neuchâtel",
    2009: "Neuchâtel 9",
    2010: "Neuchâtel",
    2012: "Auvernier",
    2013: "Colombier",
    2014: "Bôle",
    2015: "Areuse",
    2016: "Cortaillod",
    2017: "Boudry",
    2019: "Chambrelien - Rochefort",
    2022: "Bevaix",
    2023: "Gorgier",
    2024: "St-Aubin-Sauges",
    2025: "Chez-le-Bart",
    2027: "Montalchez - Fresens",
    2028: "Vaumarcus",
    2034: "Peseux",
    2035: "Corcelles",
    2036: "Cormondrèche",
    2037: "Montezillon - Montmollin",
    2042: "Valangin",
    2043: "Boudevilliers",
    2046: "Fontaines",
    2052: "Fontainemelon - La Vue-des-Alpes",
    2053: "Cernier",
    2054: "Les Vieux-Prés - Chézard-St-Martin",
    2056: "Dombresson",
    2057: "Villiers",
    2058: "Le Pâquier",
    2063: "Vilars - Saules - Fenin - Engollon",
    2065: "Savagnier",
    2067: "Chaumont",
    2068: "Hauterive",
    2072: "St-Blaise",
    2073: "Enges",
    2074: "Marin-Epagnier",
    2075: "Wavre - Thielle",
    2087: "Cornaux",
    2088: "Cressier",
    2103: "Noiraigue",
    2105: "Travers",
    2108: "Couvet",
    2112: "Môtiers",
    2113: "Boveresse",
    2114: "Fleurier",
    2115: "Buttes",
    2116: "Mont-de-Buttes",
    2117: "La Côte-aux-Fées",
    2123: "St-Sulpice",
    2124: "Les Sagnettes",
    2126: "Les Verrières",
    2127: "Les Bayards",
    2149: "Fretereules - Champ-du-Moulin - Brot-Dessous",
    2206: "Les Geneveys-sur-Coffrane",
    2207: "Coffrane",
    2208: "Les Hauts-Geneveys",
    2300: "La Chaux-de-Fonds - La Cibourg",
    2301: "La Chx-de-F. Combe-à-l'Ours - La Chaux-de-Fonds",
    2302: "La Chaux-de-Fonds",
    2303: "La Chaux-de-Fonds",
    2304: "La Chaux-de-Fonds",
    2306: "La Chaux-de-Fonds",
    2314: "La Sagne NE",
    2316: "Les Ponts-de-Martel - Petit-Martel",
    2318: "Brot-Plamboz",
    2322: "Le Crêt-du-Locle",
    2325: "Les Planchettes",
    2333: "La Cibourg - La Ferrière",
    2336: "Les Bois",
    2338: "Muriaux - Les Emibois",
    2340: "Le Noirmont",
    2345: "Les Breuleux - La Chaux-des-Breuleux - Le Cerneux-Veusil",
    2350: "Saignelégier",
    2353: "Les Pommerats",
    2354: "Goumois",
    2360: "Le Bémont",
    2362: "Montfaucon - Montfavergier",
    2363: "Les Enfers",
    2364: "St-Brais",
    2400: "Le Locle - Le Prévoux",
    2405: "La Chaux-du-Milieu",
    2406: "Les Taillères - Le Brouillet - La Châtagne - La Brévine",
    2414: "Le Cerneux-Péquignot",
    2416: "Les Brenets",
    2500: "Biel/Bienne",
    2501: "Biel/Bienne",
    2502: "Biel/Bienne",
    2503: "Biel/Bienne",
    2504: "Biel/Bienne",
    2505: "Biel/Bienne",
    2512: "Tüscherz-Alfermée",
    2513: "Twann",
    2514: "Ligerz",
    2515: "Prêles",
    2516: "Lamboing",
    2517: "Diesse",
    2518: "Nods",
    2520: "La Neuveville",
    2523: "Lignières",
    2525: "Le Landeron",
    2532: "Macolin",
    2533: "Evilard",
    2534: "Orvin - Les Prés-d'Orvin",
    2535: "Frinvillier",
    2536: "Plagne",
    2537: "Vauffelin",
    2538: "Romont",
    2540: "Grenchen",
    2542: "Pieterlen",
    2543: "Lengnau",
    2544: "Bettlach",
    2545: "Selzach",
    2552: "Orpund",
    2553: "Safnern",
    2554: "Meinisberg",
    2555: "Brügg",
    2556: "Schwadernau - Scheuren",
    2557: "Studen",
    2558: "Aegerten",
    2560: "Nidau",
    2562: "Port",
    2563: "Ipsach",
    2564: "Bellmund",
    2565: "Jens",
    2572: "Sutz - Mörigen",
    2575: "Hagneck - Täuffelen - Gerolfingen",
    2576: "Lüscherz",
    2577: "Finsterhennen - Siselen",
    2603: "Péry",
    2604: "La Heutte",
    2605: "Sonceboz-Sombeval",
    2606: "Corgémont",
    2607: "Cortébert",
    2608: "Courtelary - Montagne-de-Courtelary",
    2610: "St-Imier - Mont-Crosin - Mont-Soleil - Les Pontins",
    2612: "Cormoret",
    2613: "Villeret",
    2615: "Montagne-de-Sonvilier - Sonvilier",
    2616: "La Cibourg - Renan",
    2710: "Tavannes",
    2712: "Le Fuet",
    2713: "Bellelay",
    2714: "Le Prédame - Les Genevez",
    2715: "Monible - Châtelat",
    2716: "Sornetan",
    2717: "Fornet-Dessous - Rebévelier",
    2718: "Lajoux - Fornet-Dessus",
    2720: "La Tanne - Tramelan",
    2722: "Les Reussilles",
    2723: "Mont-Tramelan",
    2732: "Loveresse - Saicourt - Saules - Reconvilier",
    2733: "Pontenet",
    2735: "Bévilard - Malleray - Champoz",
    2736: "Sorvilier",
    2738: "Court",
    2740: "Moutier",
    2742: "Perrefitte",
    2743: "Eschert",
    2744: "Belprahon",
    2745: "Grandval",
    2746: "Crémines",
    2747: "Seehof - Corcelles",
    2748: "Souboz - Les Ecorcheresses",
    2762: "Roches",
    2800: "Delémont",
    2802: "Develier",
    2803: "Bourrignon",
    2805: "Soyhières",
    2806: "Mettembert",
    2807: "Lucelle - Pleigne",
    2812: "Movelier",
    2813: "Ederswiler",
    2814: "Roggenburg",
    2822: "Courroux",
    2823: "Courcelon",
    2824: "Vicques",
    2825: "Courchapoix",
    2826: "Corban",
    2827: "Schelten - Mervelier",
    2828: "Montsevelier",
    2829: "Vermes",
    2830: "Vellerat - Courrendlin",
    2832: "Rebeuvelier",
    2842: "Rossemaison",
    2843: "Châtillon",
    2852: "Courtételle",
    2853: "Courfaivre",
    2854: "Bassecourt",
    2855: "Glovelier",
    2856: "Boécourt",
    2857: "Montavon",
    2863: "Undervelier",
    2864: "Soulce",
    2873: "Saulcy",
    2882: "St-Ursanne",
    2883: "Montmelon",
    2884: "Montenol",
    2885: "Epauvillers",
    2886: "Epiquerez",
    2887: "Soubey",
    2888: "Seleute",
    2889: "Ocourt",
    2900: "Porrentruy",
    2902: "Fontenais",
    2903: "Villars-sur-Fontenais",
    2904: "Bressaucourt",
    2905: "Courtedoux",
    2906: "Chevenez",
    2907: "Rocourt",
    2908: "Grandfontaine",
    2912: "Roche-d'Or - Réclère",
    2914: "Damvant",
    2915: "Bure",
    2916: "Fahy",
    2922: "Courchavon",
    2923: "Courtemaîche",
    2924: "Montignez",
    2925: "Buix",
    2926: "Boncourt",
    2932: "Coeuve",
    2933: "Damphreux - Lugnez",
    2935: "Beurnevésin",
    2942: "Alle",
    2943: "Vendlincourt",
    2944: "Bonfol",
    2946: "Miécourt",
    2947: "Charmoille",
    2950: "Courgenay - Courtemautruy",
    2952: "Cornol",
    2953: "Fregiécourt - Pleujouse",
    2954: "Asuel",
    3000: "Bern",
    3001: "Bern",
    3002: "Bern PostFinance",
    3003: "Bern",
    3004: "Bern",
    3005: "Bern",
    3006: "Bern",
    3007: "Bern",
    3008: "Bern",
    3010: "Bern",
    3011: "Bern",
    3012: "Bern",
    3013: "Bern",
    3014: "Bern",
    3015: "Bern",
    3018: "Bern",
    3019: "Bern",
    3020: "Bern",
    3024: "Bern",
    3027: "Bern",
    3029: "Bern",
    3030: "Bern",
    3032: "Hinterkappelen",
    3033: "Wohlen b. Bern",
    3034: "Murzelen",
    3035: "Frieswil",
    3036: "Detligen",
    3037: "Herrenschwanden",
    3038: "Kirchlindach",
    3039: "Bern",
    3040: "Bern",
    3041: "Bern UBS",
    3042: "Ortschwaben",
    3043: "Uettligen",
    3044: "Innerberg",
    3045: "Meikirch",
    3046: "Wahlendorf",
    3047: "Bremgarten b. Bern",
    3048: "Worblaufen",
    3049: "Säriswil",
    3050: "Bern Swisscom",
    3052: "Zollikofen",
    3053: "Lätti - Münchenbuchsee - Wiggiswil - Diemerswil - Deisswil b. Münchenbuchsee",
    3054: "Schüpfen",
    3063: "Ittigen",
    3065: "Bolligen",
    3066: "Stettlen",
    3067: "Boll",
    3068: "Utzigen",
    3071: "Ostermundigen",
    3072: "Ostermundigen",
    3073: "Gümligen",
    3074: "Muri b. Bern",
    3075: "Rüfenacht - Vielbringen b. Worb",
    3076: "Worb",
    3077: "Enggistein",
    3078: "Richigen",
    3082: "Schlosswil",
    3083: "Trimstein",
    3084: "Wabern",
    3085: "Wabern Weihnachten",
    3086: "Englisberg - Zimmerwald",
    3087: "Niedermuhlern",
    3088: "Oberbütschel - Rüeggisberg",
    3089: "Hinterfultigen",
    3095: "Spiegel b. Bern",
    3096: "Oberbalm",
    3097: "Liebefeld",
    3098: "Köniz - Schliern b. Köniz",
    3099: "Rüti b. Riggisberg",
    3110: "Münsingen",
    3111: "Tägertschi",
    3112: "Allmendingen b. Bern",
    3113: "Rubigen",
    3114: "Wichtrach",
    3115: "Gerzensee",
    3116: "Mühledorf - Kirchdorf - Noflen",
    3122: "Kehrsatz",
    3123: "Belp",
    3124: "Belpberg",
    3125: "Toffen",
    3126: "Gelterfingen - Kaufdorf",
    3127: "Mühlethurnen - Lohnstorf",
    3128: "Rümligen - Kirchenthurnen",
    3132: "Riggisberg",
    3144: "Gasel",
    3145: "Niederscherli",
    3147: "Mittelhäusern",
    3148: "Lanzenhäusern",
    3150: "Schwarzenburg",
    3152: "Mamishaus",
    3153: "Rüschegg Gambach",
    3154: "Rüschegg Heubach",
    3155: "Helgisried-Rohrbach",
    3156: "Riffenmatt",
    3157: "Milken",
    3158: "Guggisberg",
    3159: "Riedstätt",
    3172: "Niederwangen b. Bern",
    3173: "Oberwangen b. Bern",
    3174: "Thörishaus",
    3175: "Flamatt",
    3176: "Neuenegg",
    3177: "Laupen",
    3178: "Bösingen",
    3179: "Kriechenwil",
    3182: "Ueberstorf",
    3183: "Albligen",
    3184: "Wünnewil",
    3185: "Schmitten",
    3186: "Düdingen",
    3202: "Frauenkappelen",
    3203: "Mühleberg",
    3204: "Rosshäusern",
    3205: "Gümmenen",
    3206: "Gammen - Rizenbach - Biberen - Ferenbalm - Wallenbuch",
    3207: "Wileroltigen - Golaten",
    3208: "Gurbrü",
    3210: "Kerzers",
    3212: "Kleingurmels - Gurmels",
    3213: "Kleinbösingen - Liebistorf",
    3214: "Ulmiz",
    3215: "Lurtigen - Büchslen - Gempenach",
    3216: "Ried b. Kerzers - Agriswil",
    3225: "Müntschemier",
    3226: "Treiten",
    3232: "Ins",
    3233: "Tschugg",
    3234: "Vinelz",
    3235: "Erlach",
    3236: "Gampelen",
    3237: "Brüttelen",
    3238: "Gals",
    3250: "Lyss",
    3251: "Ruppoldsried - Wengi b. Büren",
    3252: "Worben",
    3253: "Schnottwil",
    3254: "Messen - Balm b. Messen",
    3255: "Rapperswil",
    3256: "Dieterswil - Bangerten b. Dieterswil - Seewil",
    3257: "Ammerzwil - Grossaffoltern",
    3262: "Suberg",
    3263: "Büetigen",
    3264: "Diessbach b. Büren",
    3266: "Wiler b. Seedorf",
    3267: "Seedorf",
    3268: "Lobsigen",
    3270: "Aarberg",
    3271: "Radelfingen b. Aarberg",
    3272: "Walperswil - Epsach",
    3273: "Kappelen",
    3274: "Merzligen - Hermrigen - Bühl b. Aarberg",
    3280: "Greng - Murten - Meyriez",
    3282: "Bargen",
    3283: "Kallnach - Niederried b. Kallnach",
    3284: "Fräschels",
    3285: "Galmiz",
    3286: "Muntelier",
    3292: "Busswil",
    3293: "Dotzigen",
    3294: "Meienried - Büren an der Aare",
    3295: "Rüti b. Büren",
    3296: "Arch",
    3297: "Leuzigen",
    3298: "Oberwil b. Büren",
    3302: "Moosseedorf",
    3303: "Ballmoos - Münchringen - Jegenstorf - Zuzwil",
    3305: "Iffwil - Scheunen",
    3306: "Etzelkofen",
    3307: "Brunnenthal",
    3308: "Grafenried",
    3309: "Kernenried - Zauggenried",
    3312: "Fraubrunnen",
    3313: "Büren zum Hof",
    3314: "Schalunen",
    3315: "Kräiligen - Bätterkinden",
    3317: "Mülchi - Limpach",
    3321: "Schönbühl Einkaufszentrum",
    3322: "Mattstetten - Urtenen-Schönbühl",
    3323: "Bäriswil",
    3324: "Mötschwil - Hindelbank",
    3325: "Hettiswil b. Hindelbank",
    3326: "Krauchthal",
    3360: "Herzogenbuchsee",
    3362: "Niederönz",
    3363: "Oberönz",
    3365: "Seeberg - Grasswil",
    3366: "Bettenhausen - Bollodingen",
    3367: "Thörigen - Ochlenberg",
    3368: "Bleienbach",
    3372: "Wanzwil",
    3373: "Röthenbach Herzogenbuchsee - Heimenhausen",
    3374: "Wangenried",
    3375: "Inkwil",
    3376: "Berken - Graben",
    3377: "Walliswil b. Wangen",
    3380: "Wangen an der Aare - Walliswil b. Niederbipp",
    3400: "Burgdorf",
    3401: "Burgdorf",
    3402: "Burgdorf",
    3412: "Heimiswil",
    3413: "Kaltacker",
    3414: "Oberburg",
    3415: "Rüegsauschachen - Schafhausen im Emmental - Hasle b. Burgdorf",
    3416: "Affoltern im Emmental",
    3417: "Rüegsau",
    3418: "Rüegsbach",
    3419: "Biembach im Emmental",
    3421: "Rüti b. Lyssach - Lyssach",
    3422: "Alchenflüh - Kirchberg - Rüdtligen",
    3423: "Ersigen",
    3424: "Niederösch - Oberösch",
    3425: "Koppigen - Willadingen",
    3426: "Aefligen",
    3427: "Utzenstorf",
    3428: "Wiler b. Utzenstorf",
    3429: "Höchstetten - Hellsau",
    3432: "Lützelflüh-Goldbach",
    3433: "Schwanden im Emmental",
    3434: "Obergoldbach - Landiswil",
    3435: "Ramsei",
    3436: "Zollbrück",
    3437: "Rüderswil",
    3438: "Lauperswil",
    3439: "Ranflüh",
    3452: "Grünenmatt",
    3453: "Heimisbach",
    3454: "Sumiswald",
    3455: "Grünen",
    3456: "Trachselwald",
    3457: "Wasen im Emmental",
    3462: "Weier im Emmental",
    3463: "Häusernmoos im Emmental",
    3464: "Schmidigen-Mühleweg",
    3465: "Dürrenroth",
    3472: "Rumendingen - Wynigen",
    3473: "Alchenstorf",
    3474: "Rüedisbach",
    3475: "Riedtwil - Hermiswil",
    3476: "Oschwand",
    3503: "Gysenstein",
    3504: "Oberhünigen - Niederhünigen",
    3506: "Grosshöchstetten",
    3507: "Biglen",
    3508: "Arni",
    3510: "Häutligen - Konolfingen - Freimettigen",
    3512: "Walkringen",
    3513: "Bigenthal",
    3531: "Oberthal",
    3532: "Zäziwil - Mirchel",
    3533: "Bowil",
    3534: "Signau",
    3535: "Schüpbach",
    3536: "Aeschau",
    3537: "Eggiwil",
    3538: "Röthenbach im Emmental",
    3543: "Emmenmatt",
    3550: "Langnau im Emmental",
    3551: "Oberfrittenbach",
    3552: "Bärau",
    3553: "Gohl",
    3555: "Trubschachen",
    3556: "Trub",
    3557: "Fankhaus (Trub)",
    3600: "Thun",
    3601: "Thun",
    3602: "Thun",
    3603: "Thun",
    3604: "Thun",
    3605: "Thun",
    3607: "Thun",
    3608: "Thun",
    3609: "Thun",
    3612: "Steffisburg",
    3613: "Steffisburg",
    3614: "Unterlangenegg",
    3615: "Heimenschwand",
    3616: "Schwarzenegg",
    3617: "Fahrni b. Thun",
    3618: "Süderen",
    3619: "Eriz - Innereriz",
    3622: "Homberg b. Thun",
    3623: "Teuffenthal b. Thun - Horrenbach - Buchen",
    3624: "Goldiwil (Thun) - Schwendibach",
    3625: "Heiligenschwendi",
    3626: "Hünibach",
    3627: "Heimberg",
    3628: "Kienersrüti - Uttigen",
    3629: "Oppligen - Kiesen - Jaberg",
    3631: "Höfen b. Thun",
    3632: "Oberstocken - Niederstocken",
    3633: "Amsoldingen",
    3634: "Thierachern",
    3635: "Uebeschi",
    3636: "Forst b. Längenbühl - Längenbühl",
    3638: "Blumenstein - Pohlern",
    3645: "Gwatt (Thun) - Zwieselberg",
    3646: "Einigen",
    3647: "Reutigen",
    3652: "Hilterfingen",
    3653: "Oberhofen am Thunersee",
    3654: "Gunten",
    3655: "Sigriswil",
    3656: "Tschingel ob Gunten - Ringoldswil - Aeschlen ob Gunten",
    3657: "Schwanden (Sigriswil)",
    3658: "Merligen",
    3661: "Uetendorf",
    3662: "Seftigen",
    3663: "Gurzelen",
    3664: "Burgistein",
    3665: "Wattenwil",
    3671: "Brenzikofen - Herbligen",
    3672: "Oberdiessbach - Aeschlen b. Oberdiessbach",
    3673: "Linden",
    3674: "Bleiken b. Oberdiessbach",
    3700: "Spiez",
    3702: "Hondrich",
    3703: "Aeschi b. Spiez - Aeschiried",
    3704: "Krattigen",
    3705: "Faulensee",
    3706: "Leissigen",
    3707: "Därligen",
    3711: "Mülenen - Emdthal",
    3713: "Reichenbach im Kandertal",
    3714: "Frutigen - Wengi b. Frutigen",
    3715: "Adelboden",
    3716: "Kandergrund",
    3717: "Blausee-Mitholz",
    3718: "Kandersteg",
    3722: "Scharnachtal",
    3723: "Kiental",
    3724: "Ried (Frutigen)",
    3725: "Achseten",
    3752: "Wimmis",
    3753: "Oey",
    3754: "Diemtigen",
    3755: "Horboden",
    3756: "Zwischenflüh",
    3757: "Schwenden im Diemtigtal",
    3758: "Latterbach",
    3762: "Erlenbach im Simmental",
    3763: "Därstetten",
    3764: "Weissenburg",
    3765: "Oberwil im Simmental",
    3766: "Boltigen",
    3770: "Zweisimmen",
    3771: "Blankenburg",
    3772: "St. Stephan",
    3773: "Matten (St. Stephan)",
    3775: "Lenk im Simmental",
    3776: "Oeschseite",
    3777: "Saanenmöser",
    3778: "Schönried",
    3780: "Gstaad",
    3781: "Turbach",
    3782: "Lauenen b. Gstaad",
    3783: "Grund b. Gstaad",
    3784: "Feutersoey",
    3785: "Gsteig b. Gstaad",
    3792: "Saanen",
    3800: "Sundlauenen - Matten b. Interlaken - Interlaken - Unterseen",
    3801: "Jungfraujoch",
    3802: "Interlaken Ost",
    3803: "Beatenberg",
    3804: "Habkern",
    3805: "Goldswil b. Interlaken",
    3806: "Bönigen b. Interlaken",
    3807: "Iseltwald",
    3812: "Wilderswil",
    3813: "Saxeten",
    3814: "Gsteigwiler",
    3815: "Gündlischwand - Zweilütschinen",
    3816: "Lütschental - Burglauenen",
    3818: "Grindelwald",
    3822: "Lauterbrunnen - Isenfluh",
    3823: "Eigergletscher - Kleine Scheidegg - Wengen",
    3824: "Stechelberg",
    3825: "Mürren",
    3826: "Gimmelwald",
    3852: "Ringgenberg",
    3853: "Niederried b. Interlaken",
    3854: "Oberried am Brienzersee",
    3855: "Axalp - Brienz - Schwanden b. Brienz",
    3856: "Brienzwiler",
    3857: "Unterbach",
    3858: "Hofstetten b. Brienz",
    3860: "Meiringen - Schattenhalb - Brünig - Rosenlaui",
    3862: "Innertkirchen",
    3863: "Gadmen",
    3864: "Guttannen",
    3900: "Brig - Brigerbad - Gamsen",
    3901: "Rothwald",
    3902: "Glis",
    3903: "Mund - Birgisch",
    3904: "Naters",
    3905: "Saas-Almagell",
    3906: "Saas-Fee",
    3907: "Simplon Hospiz - Simplon Dorf - Gondo - Gabi (Simplon)",
    3908: "Saas-Balen",
    3910: "Saas-Grund",
    3911: "Ried-Brig",
    3912: "Termen",
    3913: "Rosswald",
    3914: "Blatten b. Naters - Belalp",
    3916: "Ferden",
    3917: "Goppenstein - Kippel",
    3918: "Wiler (Lötschen)",
    3919: "Blatten (Lötschen)",
    3920: "Zermatt",
    3922: "Eisten - Stalden - Kalpetran",
    3923: "Törbel",
    3924: "St. Niklaus - Gasenried",
    3925: "Grächen",
    3926: "Embd",
    3927: "Herbriggen",
    3928: "Randa",
    3929: "Täsch",
    3930: "Visp - Eyholz",
    3931: "Lalden",
    3932: "Visperterminen",
    3933: "Staldenried",
    3934: "Zeneggen",
    3935: "Bürchen",
    3937: "Baltschieder",
    3938: "Ausserberg",
    3939: "Eggerberg",
    3940: "Steg",
    3942: "Raron - St. German - Niedergesteln",
    3943: "Eischoll",
    3944: "Unterbäch",
    3945: "Gampel - Niedergampel",
    3946: "Turtmann - Gruben",
    3947: "Ergisch",
    3948: "Unterems - Oberems",
    3949: "Hohtenn",
    3951: "Agarn",
    3952: "Susten",
    3953: "Varen - Inden - Leuk Stadt",
    3954: "Leukerbad",
    3955: "Albinen",
    3956: "Guttet-Feschel",
    3957: "Erschmatt - Bratsch",
    3960: "Muraz (Sierre) - Sierre - Loc - Niouc - Corin-de-la-Crête",
    3961: "Zinal - St-Jean - St-Luc - Chandolin - Vissoie - Grimentz - Ayer - Grimentz",
    3963: "Montana - Aminona - Crans-Montana",
    3965: "Chippis",
    3966: "Chalais - Réchy",
    3967: "Vercorin",
    3968: "Veyras",
    3970: "Salgesch",
    3971: "Chermignon - Chermignon-d'en-Bas - Ollon",
    3972: "Miège",
    3973: "Venthône",
    3974: "Mollens",
    3975: "Randogne",
    3976: "Champzabé - Noës",
    3977: "Granges",
    3978: "Flanthey",
    3979: "Grône",
    3982: "Bitsch",
    3983: "Greich - Mörel - Bister - Filet - Goppisberg",
    3984: "Fieschertal - Fiesch",
    3985: "Münster - Geschinen",
    3986: "Ried-Mörel",
    3987: "Riederalp",
    3988: "Ulrichen - Obergesteln",
    3989: "Blitzingen - Selkingen - Ritzingen - Biel - Niederwald",
    3991: "Betten",
    3992: "Bettmeralp",
    3993: "Grengiols",
    3994: "Lax - Martisberg",
    3995: "Ernen - Mühlebach (Goms) - Steinhaus - Ausserbinn",
    3996: "Binn",
    3997: "Bellwald",
    3998: "Reckingen - Gluringen",
    3999: "Oberwald",
    4000: "Basel",
    4001: "Basel",
    4002: "Basel",
    4003: "Basel",
    4004: "Basel",
    4005: "Basel",
    4007: "Basel",
    4008: "Basel",
    4009: "Basel",
    4010: "Basel",
    4011: "Basel",
    4012: "Basel",
    4013: "Basel",
    4015: "Basel",
    4016: "Basel",
    4017: "Basel",
    4018: "Basel",
    4019: "Basel",
    4020: "Basel",
    4023: "Basel",
    4024: "Basel",
    4025: "Basel",
    4030: "Basel",
    4032: "Basel",
    4039: "Basel",
    4040: "Basel",
    4051: "Basel",
    4052: "Basel",
    4053: "Basel",
    4054: "Basel",
    4055: "Basel",
    4056: "Basel",
    4057: "Basel",
    4058: "Basel",
    4059: "Basel",
    4070: "Basel",
    4075: "Basel",
    4080: "Basel",
    4083: "Basel",
    4084: "Basel",
    4085: "Basel",
    4086: "Basel",
    4087: "Basel",
    4088: "Basel",
    4091: "Basel",
    4101: "Bruderholz",
    4102: "Binningen",
    4103: "Bottmingen",
    4104: "Oberwil",
    4105: "Biel-Benken",
    4106: "Therwil",
    4107: "Ettingen",
    4108: "Witterswil",
    4112: "Flüh - Bättwil",
    4114: "Hofstetten",
    4115: "Mariastein",
    4116: "Metzerlen",
    4117: "Burg im Leimental",
    4118: "Rodersdorf",
    4123: "Allschwil",
    4124: "Schönenbuch",
    4125: "Riehen",
    4126: "Bettingen",
    4127: "Birsfelden",
    4132: "Muttenz",
    4133: "Pratteln",
    4142: "Münchenstein",
    4143: "Dornach",
    4144: "Arlesheim",
    4145: "Gempen",
    4146: "Hochwald",
    4147: "Aesch",
    4148: "Pfeffingen",
    4153: "Reinach",
    4202: "Duggingen",
    4203: "Grellingen",
    4204: "Himmelried",
    4206: "Seewen",
    4207: "Bretzwil",
    4208: "Nunningen",
    4222: "Zwingen",
    4223: "Blauen",
    4224: "Nenzlingen",
    4225: "Brislach",
    4226: "Breitenbach",
    4227: "Büsserach",
    4228: "Erschwil",
    4229: "Beinwil",
    4232: "Fehren",
    4233: "Meltingen",
    4234: "Zullwil",
    4242: "Laufen",
    4243: "Dittingen",
    4244: "Röschenz",
    4245: "Kleinlützel",
    4246: "Wahlen b. Laufen",
    4247: "Grindel",
    4252: "Bärschwil",
    4253: "Liesberg",
    4254: "Liesberg Dorf",
    4302: "Augst",
    4303: "Kaiseraugst",
    4304: "Giebenach",
    4305: "Olsberg",
    4310: "Rheinfelden",
    4312: "Magden",
    4313: "Möhlin",
    4314: "Zeiningen",
    4315: "Zuzgen",
    4316: "Hellikon",
    4317: "Wegenstetten",
    4322: "Mumpf",
    4323: "Wallbach",
    4324: "Obermumpf",
    4325: "Schupfart",
    4332: "Stein",
    4333: "Münchwilen",
    4334: "Sisseln",
    4402: "Frenkendorf",
    4410: "Liestal",
    4411: "Seltisberg",
    4412: "Nuglar",
    4413: "Büren",
    4414: "Füllinsdorf",
    4415: "Lausen",
    4416: "Bubendorf",
    4417: "Ziefen",
    4418: "Reigoldswil",
    4419: "Lupsingen",
    4421: "St. Pantaleon",
    4422: "Arisdorf",
    4423: "Hersberg",
    4424: "Arboldswil",
    4425: "Titterten",
    4426: "Lauwil",
    4431: "Bennwil",
    4432: "Lampenberg",
    4433: "Ramlinsburg",
    4434: "Hölstein",
    4435: "Niederdorf",
    4436: "Liedertswil - Oberdorf",
    4437: "Waldenburg",
    4438: "Langenbruck",
    4441: "Thürnen",
    4442: "Diepflingen",
    4443: "Wittinsburg",
    4444: "Rümlingen",
    4445: "Häfelfingen",
    4446: "Buckten",
    4447: "Känerkinden",
    4448: "Läufelfingen",
    4450: "Sissach",
    4451: "Wintersingen",
    4452: "Itingen",
    4453: "Nusshof",
    4455: "Zunzgen",
    4456: "Tenniken",
    4457: "Diegten",
    4458: "Eptingen",
    4460: "Gelterkinden",
    4461: "Böckten",
    4462: "Rickenbach",
    4463: "Buus",
    4464: "Maisprach",
    4465: "Hemmiken",
    4466: "Ormalingen",
    4467: "Rothenfluh",
    4468: "Kienberg",
    4469: "Anwil",
    4492: "Tecknau",
    4493: "Wenslingen",
    4494: "Oltingen",
    4495: "Zeglingen",
    4496: "Kilchberg",
    4497: "Rünenberg",
    4500: "Solothurn",
    4501: "Solothurn",
    4502: "Solothurn",
    4503: "Solothurn",
    4509: "Solothurn",
    4512: "Bellach",
    4513: "Langendorf",
    4514: "Lommiswil",
    4515: "Weissenstein b. Solothurn - Oberdorf",
    4522: "Rüttenen",
    4523: "Niederwil",
    4524: "Günsberg - Oberbalmberg - Balmberg",
    4525: "Balm b. Günsberg",
    4528: "Zuchwil",
    4532: "Feldbrunnen",
    4533: "Riedholz",
    4534: "Flumenthal",
    4535: "Hubersdorf - Kammersrohr",
    4536: "Attiswil",
    4537: "Wiedlisbach",
    4538: "Oberbipp",
    4539: "Farnern - Rumisberg",
    4542: "Luterbach",
    4543: "Deitingen",
    4551: "Derendingen",
    4552: "Derendingen",
    4553: "Subingen",
    4554: "Etziken - Hüniken",
    4556: "Aeschi - Burgäschi - Steinhof - Bolken",
    4557: "Horriwil",
    4558: "Heinrichswil - Hersiwil - Winistorf",
    4562: "Biberist",
    4563: "Gerlafingen",
    4564: "Zielebach - Obergerlafingen",
    4565: "Recherswil",
    4566: "Oekingen - Kriegstetten - Halten",
    4571: "Ichertswil - Lüterkofen",
    4573: "Lohn-Ammannsegg",
    4574: "Lüsslingen - Nennigkofen",
    4576: "Tscheppach",
    4577: "Hessigkofen",
    4578: "Bibern",
    4579: "Gossliwil",
    4581: "Küttigkofen",
    4582: "Brügglen",
    4583: "Mühledorf - Aetigkofen",
    4584: "Gächliwil - Lüterswil",
    4585: "Biezwil",
    4586: "Kyburg-Buchegg",
    4587: "Aetingen",
    4588: "Unterramsern - Oberramsern - Brittern",
    4600: "Olten",
    4601: "Olten 1 Fächer",
    4603: "Olten",
    4612: "Wangen b. Olten",
    4613: "Rickenbach",
    4614: "Hägendorf",
    4615: "Allerheiligenberg",
    4616: "Kappel",
    4617: "Gunzgen",
    4618: "Boningen",
    4620: "Härkingen",
    4621: "Härkingen",
    4622: "Egerkingen",
    4623: "Neuendorf",
    4624: "Härkingen",
    4625: "Oberbuchsiten",
    4626: "Niederbuchsiten",
    4628: "Wolfwil",
    4629: "Fulenbach",
    4632: "Trimbach",
    4633: "Hauenstein",
    4634: "Wisen",
    4652: "Winznau",
    4653: "Obergösgen",
    4654: "Lostorf",
    4655: "Stüsslingen - Rohr b. Olten",
    4656: "Starrkirch-Wil",
    4657: "Dulliken",
    4658: "Däniken",
    4663: "Aarburg",
    4665: "Oftringen",
    4702: "Oensingen",
    4703: "Kestenholz",
    4704: "Wolfisberg - Niederbipp",
    4710: "Balsthal",
    4712: "Laupersdorf",
    4713: "Matzendorf",
    4714: "Aedermannsdorf",
    4715: "Herbetswil",
    4716: "Gänsbrunnen - Welschenrohr",
    4717: "Mümliswil",
    4718: "Holderbank",
    4719: "Ramiswil",
    4800: "Zofingen",
    4801: "Zofingen",
    4802: "Strengelbach",
    4803: "Vordemwald",
    4805: "Brittnau",
    4806: "Wikon",
    4807: "Zofingen PF",
    4808: "Zofingen PF",
    4809: "Zofingen PF",
    4812: "Mühlethal",
    4813: "Uerkheim",
    4814: "Bottenwil",
    4852: "Rothrist",
    4853: "Murgenthal - Riken",
    4856: "Glashütten",
    4900: "Langenthal",
    4901: "Langenthal",
    4902: "Langenthal",
    4911: "Schwarzhäusern",
    4912: "Aarwangen",
    4913: "Bannwil",
    4914: "Roggwil",
    4915: "St. Urban",
    4916: "Untersteckholz",
    4917: "Busswil b. Melchnau - Melchnau",
    4919: "Reisiswil",
    4922: "Bützberg - Thunstetten",
    4923: "Wynau",
    4924: "Obersteckholz",
    4932: "Lotzwil - Gutenburg",
    4933: "Rütschelen",
    4934: "Madiswil",
    4935: "Leimiswil",
    4936: "Kleindietwil",
    4937: "Ursenbach",
    4938: "Rohrbach - Rohrbachgraben",
    4942: "Walterswil",
    4943: "Oeschenbach",
    4944: "Auswil",
    4950: "Huttwil",
    4952: "Eriswil",
    4953: "Schwarzenbach (Huttwil)",
    4954: "Wyssachen",
    4955: "Gondiswil",
    5000: "Aarau",
    5001: "Aarau 1",
    5004: "Aarau",
    5012: "Wöschnau - Eppenberg - Schönenwerd",
    5013: "Niedergösgen",
    5014: "Gretzenbach",
    5015: "Erlinsbach",
    5017: "Barmelweid",
    5018: "Erlinsbach",
    5022: "Rombach",
    5023: "Biberstein",
    5024: "Küttigen",
    5025: "Asp",
    5026: "Densbüren",
    5027: "Herznach",
    5028: "Ueken",
    5032: "Aarau Rohr",
    5033: "Buchs",
    5034: "Suhr",
    5035: "Unterentfelden",
    5036: "Oberentfelden",
    5037: "Muhen",
    5040: "Schöftland",
    5042: "Hirschthal",
    5043: "Holziken",
    5044: "Schlossrued",
    5046: "Schmiedrued - Walde",
    5053: "Wittwil - Staffelbach",
    5054: "Kirchleerau - Moosleerau",
    5056: "Attelwil",
    5057: "Reitnau",
    5058: "Wiliberg",
    5062: "Oberhof",
    5063: "Wölflinswil",
    5064: "Wittnau",
    5070: "Frick",
    5072: "Oeschgen",
    5073: "Gipf-Oberfrick",
    5074: "Eiken",
    5075: "Hornussen",
    5076: "Bözen",
    5077: "Elfingen",
    5078: "Effingen",
    5079: "Zeihen",
    5080: "Laufenburg",
    5082: "Kaisten",
    5083: "Ittenthal",
    5084: "Rheinsulz",
    5085: "Sulz",
    5102: "Rupperswil",
    5103: "Möriken - Wildegg",
    5105: "Auenstein",
    5106: "Veltheim",
    5107: "Schinznach Dorf",
    5108: "Oberflachs",
    5112: "Thalheim",
    5113: "Holderbank",
    5116: "Schinznach Bad",
    5200: "Brugg",
    5201: "Brugg",
    5210: "Windisch",
    5212: "Hausen",
    5213: "Villnachern",
    5222: "Umiken",
    5223: "Riniken",
    5224: "Unterbözberg - Linn - Gallenkirch",
    5225: "Oberbözberg",
    5233: "Stilli",
    5234: "Villigen",
    5235: "Rüfenach",
    5236: "Remigen",
    5237: "Mönthal",
    5242: "Lupfig - Birr",
    5243: "Mülligen",
    5244: "Birrhard",
    5245: "Habsburg",
    5246: "Scherz",
    5272: "Gansingen",
    5273: "Oberhofen",
    5274: "Mettau",
    5275: "Etzgen",
    5276: "Wil",
    5277: "Hottwil",
    5300: "Turgi",
    5301: "Siggenthal Station",
    5303: "Würenlingen",
    5304: "Endingen",
    5305: "Unterendingen",
    5306: "Tegerfelden",
    5312: "Döttingen",
    5313: "Klingnau",
    5314: "Kleindöttingen",
    5315: "Böttstein",
    5316: "Felsenau - Leuggern",
    5317: "Hettenschwil",
    5318: "Mandach",
    5322: "Koblenz",
    5323: "Rietheim",
    5324: "Full-Reuenthal",
    5325: "Leibstadt",
    5326: "Schwaderloch",
    5330: "Bad Zurzach",
    5332: "Rekingen",
    5333: "Baldingen",
    5334: "Böbikon",
    5400: "Baden",
    5401: "Baden",
    5402: "Baden",
    5404: "Baden",
    5405: "Dättwil",
    5406: "Rütihof",
    5408: "Ennetbaden",
    5412: "Vogelsang - Gebenstorf",
    5413: "Birmenstorf",
    5415: "Rieden - Nussbaumen - Hertenstein",
    5416: "Kirchdorf",
    5417: "Untersiggenthal",
    5420: "Ehrendingen",
    5423: "Freienwil",
    5425: "Schneisingen",
    5426: "Lengnau",
    5430: "Wettingen",
    5431: "Wettingen Sonderdienste",
    5432: "Neuenhof",
    5436: "Würenlos",
    5442: "Fislisbach",
    5443: "Niederrohrdorf",
    5444: "Künten",
    5445: "Eggenwil",
    5452: "Oberrohrdorf",
    5453: "Remetschwil",
    5454: "Bellikon",
    5462: "Siglistorf",
    5463: "Wislikofen",
    5464: "Rümikon",
    5465: "Mellikon",
    5466: "Kaiserstuhl",
    5467: "Fisibach",
    5502: "Hunzenschwil",
    5503: "Schafisheim",
    5504: "Othmarsingen",
    5505: "Brunegg",
    5506: "Mägenwil",
    5507: "Mellingen",
    5512: "Wohlenschwil",
    5522: "Tägerig",
    5524: "Nesselnbach - Niederwil",
    5525: "Fischbach-Göslikon",
    5600: "Lenzburg - Ammerswil",
    5601: "Lenzburg Sonderdienste",
    5603: "Staufen",
    5604: "Hendschiken",
    5605: "Dottikon",
    5606: "Dintikon",
    5607: "Hägglingen",
    5608: "Stetten",
    5610: "Wohlen",
    5611: "Anglikon",
    5612: "Villmergen",
    5613: "Hilfikon",
    5614: "Sarmenstorf",
    5615: "Fahrwangen",
    5616: "Meisterschwanden",
    5617: "Tennwil",
    5618: "Bettwil",
    5619: "Büttikon - Uezwil",
    5620: "Bremgarten",
    5621: "Zufikon",
    5622: "Waltenschwil",
    5623: "Boswil",
    5624: "Bünzen - Waldhäusern",
    5625: "Kallern",
    5626: "Hermetschwil-Staffeln",
    5627: "Besenbüren",
    5628: "Aristau",
    5630: "Muri",
    5632: "Buttwil",
    5634: "Merenschwand",
    5636: "Benzenschwil",
    5637: "Beinwil (Freiamt) - Geltwil",
    5642: "Mühlau",
    5643: "Alikon - Meienberg - Sins",
    5644: "Auw",
    5645: "Aettenschwil - Fenkrieden",
    5646: "Abtwil",
    5647: "Oberrüti",
    5702: "Niederlenz",
    5703: "Seon",
    5704: "Egliswil",
    5705: "Hallwil",
    5706: "Boniswil",
    5707: "Seengen",
    5708: "Birrwil",
    5712: "Beinwil am See",
    5722: "Gränichen",
    5723: "Teufenthal",
    5724: "Dürrenäsch",
    5725: "Leutwil",
    5726: "Unterkulm",
    5727: "Oberkulm",
    5728: "Gontenschwil",
    5732: "Zetzwil",
    5733: "Leimbach",
    5734: "Reinach",
    5735: "Pfeffikon",
    5736: "Burg",
    5737: "Menziken",
    5742: "Kölliken",
    5745: "Safenwil",
    5746: "Walterswil",
    6000: "Luzern",
    6002: "Luzern",
    6003: "Luzern",
    6004: "Luzern",
    6005: "St. Niklausen - Luzern",
    6006: "Luzern",
    6007: "Luzern",
    6009: "Luzern",
    6010: "Kriens",
    6011: "Kriens",
    6012: "Obernau",
    6013: "Eigenthal",
    6014: "Luzern",
    6015: "Luzern",
    6016: "Hellbühl",
    6017: "Ruswil",
    6018: "Buttisholz",
    6019: "Sigigen",
    6020: "Emmenbrücke",
    6021: "Emmenbrücke",
    6022: "Grosswangen",
    6023: "Rothenburg",
    6024: "Hildisrieden",
    6025: "Neudorf",
    6026: "Rain",
    6027: "Römerswil",
    6028: "Herlisberg",
    6030: "Ebikon",
    6031: "Ebikon",
    6032: "Emmen",
    6033: "Buchrain",
    6034: "Inwil",
    6035: "Perlen",
    6036: "Dierikon",
    6037: "Root",
    6038: "Honau - Gisikon",
    6039: "Root Längenbold",
    6042: "Dietwil",
    6043: "Adligenswil",
    6044: "Udligenswil",
    6045: "Meggen",
    6047: "Kastanienbaum",
    6048: "Horw",
    6052: "Hergiswil",
    6053: "Alpnachstad",
    6055: "Alpnach Dorf",
    6056: "Kägiswil",
    6060: "Sarnen - Ramersberg",
    6061: "Sarnen 1",
    6062: "Wilen (Sarnen)",
    6063: "Stalden (Sarnen)",
    6064: "Kerns",
    6066: "St. Niklausen",
    6067: "Melchtal",
    6068: "Melchsee-Frutt",
    6072: "Sachseln",
    6073: "Flüeli-Ranft",
    6074: "Giswil",
    6078: "Bürglen - Lungern",
    6083: "Hasliberg Hohfluh",
    6084: "Hasliberg Wasserwendi",
    6085: "Hasliberg Goldern",
    6086: "Hasliberg Reuti",
    6102: "Malters",
    6103: "Schwarzenberg",
    6105: "Schachen",
    6106: "Werthenstein",
    6110: "Wolhusen - Fontannen b. Wolhusen",
    6112: "Doppleschwand",
    6113: "Romoos",
    6114: "Steinhuserberg",
    6122: "Menznau",
    6123: "Geiss",
    6125: "Menzberg",
    6126: "Daiwil",
    6130: "Willisau",
    6132: "Rohrmatt",
    6133: "Hergiswil b. Willisau",
    6142: "Gettnau",
    6143: "Ohmstal",
    6144: "Zell",
    6145: "Fischbach",
    6146: "Grossdietwil",
    6147: "Altbüron",
    6152: "Hüswil",
    6153: "Ufhusen",
    6154: "Hofstatt",
    6156: "Luthern - Luthern Bad",
    6160: "Entlebuch",
    6162: "Finsterwald b. Entlebuch - Entlebuch - Rengg",
    6163: "Ebnet",
    6166: "Hasle",
    6167: "Bramboden",
    6170: "Schüpfheim",
    6173: "Flühli",
    6174: "Sörenberg",
    6182: "Escholzmatt",
    6192: "Wiggen",
    6196: "Marbach",
    6197: "Schangnau",
    6203: "Sempach Station",
    6204: "Sempach",
    6205: "Eich",
    6206: "Neuenkirch",
    6207: "Nottwil",
    6208: "Oberkirch",
    6210: "Sursee",
    6211: "Buchs",
    6212: "Kaltbach - St. Erhard",
    6213: "Knutwil",
    6214: "Schenkon",
    6215: "Beromünster - Schwarzenbach",
    6216: "Mauensee",
    6217: "Kottwil",
    6218: "Ettiswil",
    6221: "Rickenbach",
    6222: "Gunzwil",
    6231: "Schlierbach",
    6232: "Geuensee",
    6233: "Büron",
    6234: "Kulmerau - Triengen",
    6235: "Winikon",
    6236: "Wilihof",
    6242: "Wauwil",
    6243: "Egolzwil",
    6244: "Nebikon",
    6245: "Ebersecken",
    6246: "Altishofen",
    6247: "Schötz",
    6248: "Alberswil",
    6252: "Dagmersellen",
    6253: "Uffikon",
    6260: "Reidermoos - Reiden - Hintermoos - Mehlsecken",
    6262: "Langnau b. Reiden",
    6263: "Richenthal",
    6264: "Pfaffnau",
    6265: "Roggliswil",
    6274: "Eschenbach",
    6275: "Ballwil",
    6276: "Hohenrain",
    6277: "Kleinwangen - Lieli",
    6280: "Urswil - Hochdorf",
    6281: "Hochdorf",
    6283: "Baldegg",
    6284: "Gelfingen - Sulz",
    6285: "Hitzkirch - Retschwil",
    6286: "Altwis",
    6287: "Aesch",
    6288: "Schongau",
    6289: "Müswangen - Hämikon",
    6294: "Ermensee",
    6295: "Mosen",
    6300: "Zug - Zugerberg",
    6301: "Zug",
    6302: "Zug",
    6303: "Zug",
    6304: "Zug",
    6310: "Zug Sonderdienste",
    6312: "Steinhausen",
    6313: "Edlibach - Finstersee - Menzingen",
    6314: "Neuägeri - Unterägeri",
    6315: "Alosen - Morgarten - Oberägeri",
    6317: "Oberwil b. Zug",
    6318: "Walchwil",
    6319: "Allenwinden",
    6330: "Cham",
    6331: "Hünenberg",
    6332: "Hagendorn",
    6333: "Hünenberg See",
    6340: "Baar - Sihlbrugg",
    6341: "Baar",
    6342: "Baar",
    6343: "Buonas - Risch - Rotkreuz - Holzhäusern",
    6344: "Meierskappel",
    6345: "Neuheim",
    6346: "Baar 3",
    6349: "Baar Sonderdienste",
    6353: "Weggis",
    6354: "Vitznau",
    6356: "Rigi Kaltbad",
    6362: "Stansstad",
    6363: "Obbürgen - Bürgenstock - Fürigen",
    6365: "Kehrsiten",
    6370: "Stans - Oberdorf",
    6371: "Stans",
    6372: "Ennetmoos",
    6373: "Ennetbürgen",
    6374: "Buochs",
    6375: "Beckenried",
    6376: "Emmetten",
    6377: "Seelisberg",
    6382: "Büren",
    6383: "Wiesenberg - Wirzweli - Niederrickenbach - Dallenwil",
    6386: "Wolfenschiessen",
    6387: "Oberrickenbach",
    6388: "Grafenort",
    6390: "Engelberg",
    6391: "Engelberg",
    6402: "Merlischachen",
    6403: "Küssnacht am Rigi",
    6404: "Greppen",
    6405: "Immensee",
    6410: "Rigi Kulm - Rigi Staffel - Rigi Scheidegg - Rigi Klösterli - Goldau",
    6414: "Oberarth",
    6415: "Arth",
    6416: "Steinerberg",
    6417: "Sattel",
    6418: "Rothenthurm",
    6422: "Steinen",
    6423: "Seewen",
    6424: "Lauerz",
    6430: "Schwyz",
    6431: "Schwyz",
    6432: "Rickenbach b. Schwyz",
    6433: "Stoos",
    6434: "Illgau",
    6436: "Ried (Muotathal) - Muotathal - Bisisthal",
    6438: "Ibach",
    6440: "Brunnen",
    6441: "Rütli",
    6442: "Gersau",
    6443: "Morschach",
    6452: "Riemenstalden - Sisikon",
    6454: "Flüelen",
    6460: "Altdorf",
    6461: "Isenthal",
    6462: "Seedorf",
    6463: "Bürglen",
    6464: "Spiringen",
    6465: "Unterschächen",
    6466: "Bauen",
    6467: "Schattdorf",
    6468: "Attinghausen",
    6469: "Haldi b. Schattdorf",
    6472: "Erstfeld",
    6473: "Silenen",
    6474: "Amsteg",
    6475: "Bristen",
    6476: "Intschi",
    6482: "Gurtnellen",
    6484: "Wassen",
    6485: "Meien",
    6487: "Göschenen",
    6490: "Andermatt",
    6491: "Realp",
    6493: "Hospental",
    6500: "Bellinzona",
    6501: "Bellinzona",
    6503: "Bellinzona",
    6512: "Giubiasco",
    6513: "Monte Carasso",
    6514: "Sementina",
    6515: "Gudo",
    6516: "Cugnasco",
    6517: "Arbedo",
    6518: "Gorduno",
    6523: "Preonzo",
    6524: "Moleno",
    6525: "Gnosca",
    6526: "Prosito",
    6527: "Lodrino",
    6528: "Camorino",
    6532: "Castione",
    6533: "Lumino",
    6534: "S. Vittore",
    6535: "Roveredo",
    6537: "Grono",
    6538: "Verdabbio",
    6540: "Castaneda",
    6541: "Sta. Maria in Calanca",
    6542: "Buseno",
    6543: "Arvigo",
    6544: "Braggio",
    6545: "Selma",
    6546: "Cauco",
    6547: "Augio",
    6548: "Rossa",
    6549: "Laura",
    6556: "Leggia",
    6557: "Cama",
    6558: "Lostallo",
    6562: "Soazza",
    6563: "Mesocco",
    6565: "S. Bernardino",
    6571: "Indemini",
    6572: "Quartino",
    6573: "Magadino",
    6574: "Vira (Gambarogno)",
    6575: "Vairano - S. Nazzaro",
    6576: "Gerra (Gambarogno)",
    6577: "Ranzo",
    6578: "Caviano",
    6579: "Piazzogna",
    6582: "Pianezzo",
    6583: "S. Antonio (Val Morobbia)",
    6584: "Carena",
    6592: "S. Antonino",
    6593: "Cadenazzo",
    6594: "Contone",
    6595: "Riazzino",
    6596: "Gordola",
    6597: "Agarone",
    6598: "Tenero",
    6599: "Robasacco",
    6600: "Muralto - Solduno - Locarno",
    6601: "Locarno",
    6602: "Muralto",
    6604: "Locarno",
    6605: "Locarno - Monte Brè sopra Locarno",
    6611: "Mosogno - Crana - Gresso",
    6612: "Ascona",
    6613: "Porto Ronco",
    6614: "Isole di Brissago - Brissago",
    6616: "Losone",
    6618: "Arcegno",
    6622: "Ronco sopra Ascona",
    6631: "Corippo",
    6632: "Vogorno",
    6633: "Lavertezzo",
    6634: "Brione (Verzasca)",
    6635: "Gerra (Verzasca)",
    6636: "Frasco",
    6637: "Sonogno",
    6644: "Orselina",
    6645: "Brione sopra Minusio",
    6646: "Contra",
    6647: "Mergoscia",
    6648: "Minusio",
    6652: "Tegna",
    6653: "Verscio",
    6654: "Cavigliano",
    6655: "Rasa - Intragna - Verdasio",
    6656: "Golino",
    6657: "Palagnedra",
    6658: "Borgnone",
    6659: "Camedo - Moneto",
    6661: "Berzona - Auressio - Loco",
    6662: "Russo",
    6663: "Comologno - Spruga",
    6664: "Vergeletto",
    6670: "Avegno",
    6672: "Gordevio",
    6673: "Maggia",
    6674: "Riveo - Someo",
    6675: "Cevio",
    6676: "Bignasco",
    6677: "Moghegno - Aurigeno",
    6678: "Lodano - Giumaglio - Coglio",
    6682: "Linescio",
    6683: "Niva (Vallemaggia) - Cerentino",
    6684: "Campo (Vallemaggia) - Cimalmotto",
    6685: "Bosco/Gurin",
    6690: "S. Carlo (Val Bavona) - Cavergno",
    6692: "Menzonio - Brontallo",
    6693: "Broglio",
    6694: "Prato-Sornico",
    6695: "Piano di Peccia - Peccia",
    6696: "Fusio",
    6702: "Claro",
    6703: "Osogna",
    6705: "Cresciano",
    6707: "Iragna",
    6710: "Biasca - Biasca Stazione",
    6713: "Malvaglia",
    6714: "Semione",
    6715: "Dongio",
    6716: "Acquarossa - Leontica - Lottigna",
    6717: "Dangio-Torre - Torre",
    6718: "Olivone - Camperio",
    6719: "Aquila",
    6720: "Ghirone - Campo (Blenio)",
    6721: "Motto (Blenio) - Ludiano",
    6722: "Corzoneso",
    6723: "Marolta - Castro - Prugiasco",
    6724: "Largario - Ponto Valentino",
    6742: "Pollegio",
    6743: "Bodio",
    6744: "Personico",
    6745: "Giornico",
    6746: "Calonico - Nivo - Lavorgo",
    6747: "Chironico",
    6748: "Anzonico",
    6749: "Sobrio - Cavagnago",
    6760: "Rossura - Molare - Faido - Carì - Calpiogna - Campello",
    6763: "Mairengo - Osco",
    6764: "Chiggiogna",
    6772: "Rodi-Fiesso",
    6773: "Prato (Leventina)",
    6774: "Dalpe",
    6775: "Ambrì",
    6776: "Piotta",
    6777: "Varenzo - Quinto",
    6780: "Madrano - Airolo",
    6781: "Villa Bedretto - Bedretto",
    6802: "Rivera",
    6803: "Camignolo",
    6804: "Bironico",
    6805: "Mezzovico",
    6806: "Sigirino",
    6807: "Taverne",
    6808: "Torricella",
    6809: "Medeglia",
    6810: "Isone",
    6814: "Lamone - Cadempino",
    6815: "Melide",
    6816: "Bissone",
    6817: "Maroggia",
    6818: "Melano",
    6821: "Rovio",
    6822: "Arogno",
    6823: "Pugerna",
    6825: "Capolago",
    6826: "Riva San Vitale",
    6827: "Brusino Arsizio",
    6828: "Balerna",
    6830: "Chiasso",
    6832: "Pedrinate - Seseglio",
    6833: "Vacallo",
    6834: "Morbio Inferiore",
    6835: "Morbio Superiore",
    6836: "Serfontana",
    6837: "Caneggio - Bruzella",
    6838: "Scudellate - Muggio - Cabbio",
    6839: "Sagno",
    6850: "Mendrisio",
    6852: "Genestrerio",
    6853: "Ligornetto",
    6854: "S. Pietro",
    6855: "Stabio",
    6862: "Rancate",
    6863: "Besazio",
    6864: "Arzo",
    6865: "Tremona",
    6866: "Meride",
    6867: "Serpiano",
    6872: "Somazzo - Salorino",
    6873: "Corteglia",
    6874: "Castel San Pietro",
    6875: "Campora - Casima - Monte",
    6877: "Coldrerio",
    6883: "Novazzano",
    6900: "Massagno - Lugano - Paradiso",
    6901: "Lugano",
    6902: "Lugano",
    6903: "Lugano",
    6904: "Lugano",
    6905: "Lugano",
    6906: "Lugano",
    6907: "Lugano",
    6908: "Massagno Caselle",
    6912: "Pazzallo",
    6913: "Carabbia",
    6914: "Carona",
    6915: "Pambio-Noranco",
    6916: "Grancia",
    6917: "Barbengo",
    6918: "Figino",
    6919: "Carabietta",
    6921: "Vico Morcote",
    6922: "Morcote",
    6924: "Sorengo",
    6925: "Gentilino",
    6926: "Montagnola",
    6927: "Agra",
    6928: "Manno",
    6929: "Gravesano",
    6930: "Bedano",
    6932: "Breganzona",
    6933: "Muzzano",
    6934: "Bioggio",
    6935: "Bosco Luganese",
    6936: "Cademario",
    6937: "Breno",
    6938: "Fescoggia - Vezio",
    6939: "Mugena - Arosio",
    6942: "Savosa",
    6943: "Vezia",
    6944: "Cureglia",
    6945: "Origlio",
    6946: "Ponte Capriasca",
    6947: "Vaglio",
    6948: "Porza",
    6949: "Comano",
    6950: "Tesserete",
    6951: "Cozzo - Signôra - Bogno - Scareglia - Odogno - Insone - Colla",
    6952: "Canobbio",
    6953: "Lugaggia",
    6954: "Bigorio - Sala Capriasca",
    6955: "Cagiallo - Oggio",
    6956: "Lopagno",
    6957: "Roveredo",
    6958: "Corticiasca - Bidogno",
    6959: "Piandera Paese - Maglio di Colla - Cimadera - Certara - Curtina",
    6960: "Odogno",
    6962: "Viganello",
    6963: "Pregassona - Cureggia",
    6964: "Davesco-Soragno",
    6965: "Cadro",
    6966: "Villa Luganese",
    6967: "Dino",
    6968: "Sonvico",
    6974: "Aldesago",
    6976: "Castagnola",
    6977: "Ruvigliana",
    6978: "Gandria",
    6979: "Brè sopra Lugano",
    6980: "Castelrotto",
    6981: "Banco - Bombinasco - Bedigliora - Biogno-Beride",
    6982: "Agno",
    6983: "Magliaso",
    6984: "Pura",
    6986: "Miglieglia - Novaggio - Curio",
    6987: "Caslano",
    6988: "Ponte Tresa",
    6989: "Purasca",
    6990: "Cassina d'Agno",
    6991: "Neggio",
    6992: "Vernate - Cimo",
    6993: "Iseo",
    6994: "Aranno",
    6995: "Madonna del Piano - Molinazzo di Monteggio",
    6996: "Ponte Cremenaga",
    6997: "Sessa",
    6998: "Termine",
    6999: "Astano",
    7000: "Chur",
    7001: "Chur",
    7002: "Chur",
    7003: "Chur ",
    7004: "Chur",
    7006: "Chur",
    7007: "Chur",
    7012: "Felsberg",
    7013: "Domat/Ems",
    7014: "Trin",
    7015: "Tamins",
    7016: "Trin Mulin",
    7017: "Flims Dorf",
    7018: "Flims Waldhaus",
    7019: "Fidaz",
    7023: "Haldenstein",
    7026: "Maladers",
    7027: "Lüen - Castiel - Calfreisen",
    7028: "Pagig - St. Peter",
    7029: "Peist",
    7031: "Laax",
    7032: "Laax",
    7050: "Arosa",
    7056: "Molinis",
    7057: "Langwies",
    7058: "Litzirüti",
    7062: "Passugg-Araschgen",
    7063: "Praden",
    7064: "Tschiertschen",
    7074: "Malix",
    7075: "Churwalden",
    7076: "Parpan",
    7077: "Valbella",
    7078: "Lenzerheide/Lai",
    7082: "Vaz/Obervaz",
    7083: "Lantsch/Lenz",
    7084: "Brienz/Brinzauls",
    7104: "Versam - Arezen",
    7106: "Tenna",
    7107: "Safien Platz",
    7109: "Thalkirch",
    7110: "Peiden",
    7111: "Pitasch",
    7112: "Duvin",
    7113: "Camuns",
    7114: "Uors (Lumnezia)",
    7115: "Surcasti",
    7116: "St. Martin (Lugnez) - Tersnaus",
    7122: "Carrera - Valendas",
    7126: "Castrisch",
    7127: "Sevgein",
    7128: "Riein",
    7130: "Schnaus - Ilanz",
    7132: "Vals",
    7133: "Obersaxen Affeier",
    7134: "Obersaxen Meierhof",
    7135: "Obersaxen Giraniga",
    7136: "Obersaxen Friggahüs",
    7137: "Flond",
    7138: "Surcuolm",
    7141: "Luven",
    7142: "Cumbel",
    7143: "Morissen",
    7144: "Vella",
    7145: "Degen",
    7146: "Vattiz",
    7147: "Vignogn",
    7148: "Lumbrein - Surin",
    7149: "Vrin",
    7151: "Schluein",
    7152: "Sagogn",
    7153: "Falera",
    7154: "Ruschein",
    7155: "Ladir",
    7156: "Rueun - Pigniu",
    7157: "Siat",
    7158: "Waltensburg/Vuorz",
    7159: "Andiast",
    7162: "Tavanasa",
    7163: "Danis",
    7164: "Dardin",
    7165: "Breil/Brigels",
    7166: "Trun",
    7167: "Zignau",
    7168: "Schlans",
    7172: "Rabius",
    7173: "Surrein",
    7174: "S. Benedetg",
    7175: "Sumvitg",
    7176: "Cumpadials",
    7180: "Disentis/Mustér",
    7182: "Cavardiras",
    7183: "Mumpé Medel",
    7184: "Curaglia",
    7185: "Platta",
    7186: "Segnas",
    7187: "Camischolas",
    7188: "Sedrun",
    7189: "Rueras",
    7202: "Says",
    7203: "Trimmis",
    7204: "Untervaz",
    7205: "Zizers",
    7206: "Igis",
    7208: "Malans",
    7212: "Seewis-Pardisla - Seewis Dorf - Seewis-Schmitten",
    7213: "Valzeina",
    7214: "Seewis-Schmitten - Seewis-Pardisla - Grüsch",
    7215: "Fanas",
    7220: "Schiers",
    7222: "Mittellunden",
    7223: "Buchen im Prättigau",
    7224: "Putz",
    7226: "Stels - Fajauna",
    7228: "Schuders - Pusserein",
    7231: "Pragg-Jenaz",
    7232: "Furna",
    7233: "Jenaz",
    7235: "Fideris",
    7240: "Küblis",
    7241: "Conters im Prättigau",
    7242: "Luzein",
    7243: "Pany",
    7244: "Gadenstätt",
    7245: "Ascharina",
    7246: "St. Antönien",
    7247: "Saas im Prättigau",
    7249: "Serneus",
    7250: "Klosters",
    7252: "Klosters Dorf",
    7260: "Davos Dorf",
    7265: "Davos Wolfgang",
    7270: "Davos Platz",
    7272: "Davos Clavadel",
    7276: "Davos Frauenkirch",
    7277: "Davos Glaris",
    7278: "Davos Monstein",
    7302: "Landquart",
    7303: "Mastrils",
    7304: "Maienfeld",
    7306: "Fläsch",
    7307: "Jenins",
    7310: "Bad Ragaz",
    7312: "Pfäfers",
    7313: "St. Margrethenberg",
    7314: "Vadura",
    7315: "Vättis",
    7317: "Vasön - Valens",
    7320: "Sargans",
    7323: "Wangs",
    7324: "Vilters",
    7325: "Schwendi im Weisstannental",
    7326: "Weisstannen",
    7402: "Bonaduz",
    7403: "Rhäzüns",
    7404: "Feldis/Veulden",
    7405: "Rothenbrunnen",
    7407: "Trans",
    7408: "Realta - Cazis",
    7411: "Sils im Domleschg",
    7412: "Scharans",
    7413: "Fürstenaubruck",
    7414: "Fürstenau",
    7415: "Pratval - Rodels",
    7416: "Almens",
    7417: "Paspels",
    7418: "Tumegl/Tomils",
    7419: "Scheid",
    7421: "Summaprada",
    7422: "Tartar",
    7423: "Sarn - Portein",
    7424: "Dalin - Präz",
    7425: "Masein",
    7426: "Flerden",
    7427: "Urmein",
    7428: "Tschappina - Glaspass",
    7430: "Rongellen - Thusis",
    7431: "Mutten - Obermutten",
    7432: "Zillis",
    7433: "Farden - Mathon - Lohn - Wergenstein - Donat",
    7434: "Sufers",
    7435: "Splügen",
    7436: "Medels im Rheinwald",
    7437: "Nufenen",
    7438: "Hinterrhein",
    7440: "Andeer",
    7442: "Clugin",
    7443: "Pignia",
    7444: "Ausserferrera",
    7445: "Innerferrera",
    7446: "Campsut-Cröt",
    7447: "Am Bach (Avers) - Cresta (Avers)",
    7448: "Juf",
    7450: "Tiefencastel",
    7451: "Alvaschein",
    7452: "Cunter",
    7453: "Tinizong",
    7454: "Rona",
    7455: "Mulegns",
    7456: "Sur - Marmorera",
    7457: "Bivio",
    7458: "Mon",
    7459: "Stierva",
    7460: "Savognin",
    7462: "Salouf",
    7463: "Riom",
    7464: "Parsonz",
    7472: "Surava",
    7473: "Alvaneu Bad",
    7477: "Filisur",
    7482: "Bergün/Bravuogn - Preda - Stugl/Stuls",
    7484: "Latsch",
    7492: "Alvaneu Dorf",
    7493: "Schmitten (Albula)",
    7494: "Davos Wiesen",
    7500: "St. Moritz",
    7502: "Bever",
    7503: "Samedan",
    7504: "Pontresina",
    7505: "Celerina/Schlarigna",
    7512: "Champfèr",
    7513: "Silvaplana - Silvaplana-Surlej",
    7514: "Fex - Sils/Segl Maria",
    7515: "Sils/Segl Baselgia",
    7516: "Maloja",
    7517: "Plaun da Lej",
    7522: "La Punt-Chamues-ch",
    7523: "Madulain",
    7524: "Zuoz",
    7525: "S-chanf",
    7526: "Cinuos-chel",
    7527: "Brail",
    7530: "Zernez",
    7532: "Tschierv",
    7533: "Fuldera",
    7534: "Lü",
    7535: "Valchava",
    7536: "Sta. Maria Val Müstair",
    7537: "Müstair",
    7542: "Susch",
    7543: "Lavin",
    7545: "Guarda",
    7546: "Ardez",
    7550: "Scuol",
    7551: "Ftan",
    7552: "Vulpera",
    7553: "Tarasp",
    7554: "Sent - Crusch",
    7556: "Ramosch",
    7557: "Vnà",
    7558: "Strada",
    7559: "Tschlin",
    7560: "Martina",
    7562: "Samnaun-Compatsch",
    7563: "Samnaun Dorf",
    7602: "Casaccia",
    7603: "Vicosoprano",
    7604: "Borgonovo",
    7605: "Stampa",
    7606: "Bondo - Promontogno",
    7608: "Castasegna",
    7610: "Soglio",
    7710: "Ospizio Bernina - Alp Grüm",
    7741: "S. Carlo (Poschiavo)",
    7742: "La Rösa - Sfazù - Poschiavo",
    7743: "Brusio - Miralago",
    7744: "Campocologno",
    7745: "Li Curt",
    7746: "Le Prese",
    7747: "Viano",
    7748: "Campascio",
    8000: "Zürich",
    8001: "Zürich",
    8002: "Zürich",
    8003: "Zürich",
    8004: "Zürich",
    8005: "Zürich",
    8006: "Zürich",
    8008: "Zürich",
    8010: "Zürich",
    8012: "Zürich",
    8015: "Zürich 15",
    8020: "Zürich 1",
    8021: "Zürich 1",
    8022: "Zürich",
    8023: "Zürich",
    8024: "Zürich",
    8026: "Zürich",
    8027: "Zürich",
    8030: "Zürich",
    8031: "Zürich",
    8032: "Zürich",
    8033: "Zürich",
    8034: "Zürich",
    8036: "Zürich",
    8037: "Zürich",
    8038: "Zürich",
    8039: "Zürich",
    8040: "Zürich",
    8041: "Zürich",
    8042: "Zürich",
    8044: "Gockhausen - Zürich",
    8045: "Zürich",
    8046: "Zürich",
    8047: "Zürich",
    8048: "Zürich",
    8049: "Zürich",
    8050: "Zürich",
    8051: "Zürich",
    8052: "Zürich",
    8053: "Zürich",
    8055: "Zürich",
    8057: "Zürich",
    8058: "Zürich",
    8060: "Zürich",
    8061: "Zürich",
    8063: "Zürich",
    8064: "Zürich",
    8065: "Zürich",
    8066: "Zürich",
    8068: "Zürich",
    8070: "Zürich",
    8071: "Zürich CS PZ",
    8074: "Zürich Voice Pub",
    8075: "Zürich",
    8080: "Zürich 80",
    8081: "Zürich",
    8085: "Zürich Versich.",
    8086: "Zürich R Digest",
    8087: "Zürich",
    8088: "Zürich",
    8090: "Zürich",
    8091: "Zürich",
    8092: "Zürich",
    8093: "Zürich",
    8096: "Zürich IBRS local",
    8098: "Zürich",
    8099: "Zürich Sonderdienste",
    8102: "Oberengstringen",
    8103: "Unterengstringen",
    8104: "Weiningen",
    8105: "Watt - Regensdorf",
    8106: "Adlikon b. Regensdorf",
    8107: "Buchs",
    8108: "Dällikon",
    8109: "Kloster Fahr",
    8112: "Otelfingen",
    8113: "Boppelsen",
    8114: "Dänikon",
    8115: "Hüttikon",
    8117: "Fällanden",
    8118: "Pfaffhausen",
    8121: "Benglen",
    8122: "Binz",
    8123: "Ebmatingen",
    8124: "Maur",
    8125: "Zollikerberg",
    8126: "Zumikon",
    8127: "Forch",
    8132: "Egg b. Zürich - Hinteregg",
    8133: "Esslingen",
    8134: "Adliswil",
    8135: "Sihlbrugg Station - Sihlwald - Langnau am Albis",
    8136: "Gattikon",
    8142: "Uitikon Waldegg",
    8143: "Uetliberg - Stallikon",
    8152: "Opfikon - Glattpark (Opfikon) - Glattbrugg",
    8153: "Rümlang",
    8154: "Oberglatt",
    8155: "Niederhasli - Nassenwil",
    8156: "Oberhasli",
    8157: "Dielsdorf",
    8158: "Regensberg",
    8162: "Sünikon - Steinmaur",
    8164: "Bachs",
    8165: "Schöfflisdorf - Schleinikon - Oberweningen",
    8166: "Niederweningen",
    8172: "Niederglatt",
    8173: "Neerach",
    8174: "Stadel b. Niederglatt",
    8175: "Windlach",
    8180: "Bülach",
    8181: "Höri",
    8182: "Hochfelden",
    8183: "Bülach Dist Ba",
    8184: "Bachenbülach",
    8185: "Winkel",
    8187: "Weiach",
    8192: "Zweidlen - Glattfelden",
    8193: "Eglisau",
    8194: "Hüntwangen",
    8195: "Wasterkingen",
    8196: "Wil",
    8197: "Rafz",
    8200: "Schaffhausen",
    8201: "Schaffhausen",
    8202: "Schaffhausen",
    8203: "Schaffhausen",
    8204: "Schaffhausen",
    8205: "Schaffhausen",
    8207: "Schaffhausen",
    8208: "Schaffhausen",
    8210: "Schaffhausen Dist Ba",
    8212: "Neuhausen am Rheinfall - Nohl",
    8213: "Neunkirch",
    8214: "Gächlingen",
    8215: "Hallau",
    8216: "Oberhallau",
    8217: "Wilchingen",
    8218: "Osterfingen",
    8219: "Trasadingen",
    8222: "Beringen",
    8223: "Guntmadingen",
    8224: "Löhningen",
    8225: "Siblingen",
    8226: "Schleitheim",
    8228: "Beggingen",
    8231: "Hemmental",
    8232: "Merishausen",
    8233: "Bargen",
    8234: "Stetten",
    8235: "Lohn",
    8236: "Opfertshofen - Büttenhardt",
    8239: "Dörflingen",
    8240: "Thayngen",
    8241: "Barzheim",
    8242: "Hofen - Bibern",
    8243: "Altdorf",
    8245: "Feuerthalen",
    8246: "Langwiesen",
    8247: "Flurlingen",
    8248: "Uhwiesen",
    8252: "Schlatt",
    8253: "Willisdorf - Diessenhofen",
    8254: "Basadingen",
    8255: "Schlattingen",
    8259: "Rheinklingen - Kaltenbach - Etzwilen - Wagenhausen",
    8260: "Stein am Rhein",
    8261: "Hemishofen",
    8262: "Ramsen",
    8263: "Buch",
    8264: "Eschenz",
    8265: "Mammern",
    8266: "Steckborn",
    8267: "Berlingen",
    8268: "Salenstein - Mannenbach-Salenstein",
    8269: "Fruthwilen",
    8272: "Ermatingen",
    8273: "Triboltingen",
    8274: "Tägerwilen - Gottlieben",
    8280: "Kreuzlingen",
    8301: "Glattzentrum b. Wallisellen",
    8302: "Kloten",
    8303: "Bassersdorf",
    8304: "Wallisellen",
    8305: "Dietlikon",
    8306: "Brüttisellen",
    8307: "Ottikon b. Kemptthal - Effretikon",
    8308: "Agasul - Illnau",
    8309: "Nürensdorf",
    8310: "Kemptthal - Grafstal",
    8311: "Brütten",
    8312: "Winterberg",
    8314: "Kyburg",
    8315: "Lindau",
    8317: "Tagelswangen",
    8320: "Fehraltorf",
    8322: "Madetswil - Gündisau",
    8325: "Effretikon Dist Ba",
    8330: "Pfäffikon - Hermatswil",
    8331: "Auslikon",
    8332: "Russikon - Rumlikon",
    8335: "Hittnau",
    8340: "Hinwil",
    8342: "Wernetshausen",
    8343: "Hinwil Dist Ba",
    8344: "Bäretswil",
    8345: "Adetswil",
    8352: "Ricketwil (Winterthur) - Elsau",
    8353: "Elgg",
    8354: "Hofstetten",
    8355: "Aadorf",
    8356: "Ettenhausen",
    8357: "Guntershausen b. Aadorf",
    8360: "Wallenwil - Eschlikon",
    8362: "Balterswil",
    8363: "Bichelsee",
    8370: "Sirnach",
    8371: "Busswil",
    8372: "Wiezikon b. Sirnach",
    8374: "Oberwangen - Dussnang",
    8376: "Au - Fischingen",
    8400: "Winterthur",
    8401: "Winterthur",
    8402: "Winterthur",
    8404: "Winterthur - Stadel (Winterthur) - Reutlingen (Winterthur)",
    8405: "Winterthur",
    8406: "Winterthur",
    8408: "Winterthur",
    8409: "Winterthur",
    8410: "Winterthur",
    8411: "Winterthur",
    8412: "Aesch (Neftenbach) - Hünikon (Neftenbach) - Riet (Neftenbach)",
    8413: "Neftenbach",
    8414: "Buch am Irchel",
    8415: "Gräslikon - Berg am Irchel",
    8416: "Flaach",
    8418: "Schlatt b. Winterthur",
    8421: "Dättlikon",
    8422: "Pfungen",
    8423: "Embrach-Embraport",
    8424: "Embrach",
    8425: "Oberembrach",
    8426: "Lufingen",
    8427: "Rorbas - Freienstein",
    8428: "Teufen",
    8442: "Hettlingen",
    8444: "Henggart",
    8447: "Dachsen",
    8450: "Andelfingen",
    8451: "Kleinandelfingen",
    8452: "Adlikon b. Andelfingen",
    8453: "Alten",
    8454: "Buchberg",
    8455: "Rüdlingen - Buchberg",
    8457: "Humlikon",
    8458: "Dorf",
    8459: "Volken",
    8460: "Marthalen",
    8461: "Oerlingen",
    8462: "Rheinau",
    8463: "Benken",
    8464: "Ellikon am Rhein",
    8465: "Wildensbuch - Rudolfingen",
    8466: "Trüllikon",
    8467: "Truttikon",
    8468: "Waltalingen - Guntalingen",
    8471: "Oberwil (Dägerlen) - Rutschwil (Dägerlen) - Dägerlen - Berg (Dägerlen) - Bänk (Dägerlen)",
    8472: "Seuzach",
    8474: "Dinhard",
    8475: "Ossingen",
    8476: "Unterstammheim",
    8477: "Oberstammheim",
    8478: "Thalheim an der Thur",
    8479: "Altikon",
    8482: "Sennhof (Winterthur)",
    8483: "Kollbrunn",
    8484: "Neschwil - Weisslingen - Theilingen",
    8486: "Rikon im Tösstal",
    8487: "Zell - Rämismühle",
    8488: "Turbenthal",
    8489: "Wildberg - Ehrikon - Schalchen",
    8492: "Wila",
    8493: "Saland",
    8494: "Bauma",
    8495: "Schmidrüti",
    8496: "Steg im Tösstal",
    8497: "Fischenthal",
    8498: "Gibswil",
    8499: "Sternenberg",
    8500: "Frauenfeld - Gerlikon",
    8501: "Frauenfeld",
    8502: "Frauenfeld",
    8503: "Frauenfeld",
    8505: "Pfyn - Dettighofen",
    8506: "Lanzenneunforn",
    8507: "Hörhausen",
    8508: "Homburg",
    8509: "Frauenfeld",
    8510: "Frauenfeld Kant. Verwaltung",
    8512: "Thundorf - Lustdorf - Wetzikon",
    8514: "Amlikon-Bissegg",
    8520: "Frauenfeld Paketzentrum - Frauenfeld Dist Ba",
    8522: "Häuslenen - Aawangen",
    8523: "Hagenbuch",
    8524: "Buch b. Frauenfeld - Uesslingen",
    8525: "Wilen b. Neunforn - Niederneunforn",
    8526: "Oberneunforn",
    8532: "Warth - Weiningen",
    8535: "Herdern",
    8536: "Hüttwilen",
    8537: "Uerschhausen - Nussbaumen",
    8542: "Wiesendangen",
    8543: "Gundetswil - Kefikon - Bertschikon",
    8544: "Attikon",
    8545: "Rickenbach Sulz - Rickenbach",
    8546: "Islikon - Kefikon - Menzengrüt",
    8547: "Gachnang",
    8548: "Ellikon an der Thur",
    8552: "Felben-Wellhausen",
    8553: "Hüttlingen - Eschikofen - Harenwilen - Mettendorf",
    8554: "Bonau - Müllheim-Wigoltingen",
    8555: "Müllheim Dorf",
    8556: "Lamperswil - Engwang - Wigoltingen - Illhart",
    8558: "Raperswilen",
    8560: "Märstetten",
    8561: "Ottoberg",
    8564: "Lipperswil - Hattenhausen - Wäldi - Sonterswil - Engwilen - Gunterswilen - Hefenhausen - Wagerswil",
    8565: "Hugelshofen",
    8566: "Neuwilen - Dotnacht - Lippoldswilen - Ellighausen",
    8570: "Weinfelden",
    8572: "Berg - Guntershausen b. Berg - Andhausen - Graltshausen",
    8573: "Alterswilen - Siegershausen - Altishausen",
    8574: "Dettighofen (Lengwil) - Illighausen - Oberhofen - Lengwil",
    8575: "Istighofen - Bürglen",
    8576: "Mauren",
    8577: "Schönholzerswilen",
    8580: "Biessenhofen - Hefenhofen - Sommeri - Hagenwil b. Amriswil - Amriswil",
    8581: "Schocherswil",
    8582: "Dozwil",
    8583: "Donzhausen - Sulgen - Götighofen",
    8584: "Leimbach - Opfershofen",
    8585: "Herrenhof - Schönenbaumgarten - Zuben - Langrickenbach - Mattwil - Klarsreuti - Happerswil - Birwinken",
    8586: "Kümmertshausen - Erlen - Ennetaach - Riedt b. Erlen - Engishofen - Andwil - Buchackern - Buch b. Kümmertshausen",
    8587: "Oberaach",
    8588: "Zihlschlacht",
    8589: "Sitterdorf",
    8590: "Romanshorn",
    8592: "Uttwil",
    8593: "Kesswil",
    8594: "Güttingen",
    8595: "Altnau",
    8596: "Münsterlingen - Scherzingen",
    8597: "Landschlacht",
    8598: "Bottighofen",
    8599: "Salmsach",
    8600: "Dübendorf",
    8602: "Wangen b. Dübendorf",
    8603: "Schwerzenbach",
    8604: "Volketswil",
    8605: "Gutenswil",
    8606: "Nänikon - Greifensee",
    8607: "Aathal-Seegräben",
    8608: "Bubikon",
    8610: "Uster",
    8612: "Uster 2",
    8613: "Uster 3",
    8614: "Bertschikon (Gossau ZH) - Sulzbach",
    8615: "Wermatswil - Freudwil",
    8616: "Riedikon",
    8617: "Mönchaltorf",
    8618: "Oetwil am See",
    8620: "Wetzikon",
    8621: "Wetzikon 4",
    8622: "Wetzikon",
    8623: "Wetzikon",
    8624: "Grüt (Gossau ZH)",
    8625: "Gossau",
    8626: "Ottikon (Gossau ZH)",
    8627: "Grüningen",
    8630: "Rüti",
    8632: "Tann",
    8633: "Wolfhausen",
    8634: "Hombrechtikon",
    8635: "Dürnten",
    8636: "Wald",
    8637: "Laupen",
    8638: "Goldingen",
    8639: "Faltigberg",
    8640: "Rapperswil - Hurden",
    8645: "Jona",
    8646: "Wagen",
    8700: "Küsnacht",
    8702: "Zollikon",
    8703: "Erlenbach",
    8704: "Herrliberg",
    8706: "Meilen",
    8707: "Uetikon am See",
    8708: "Männedorf",
    8712: "Stäfa",
    8713: "Uerikon",
    8714: "Feldbach",
    8715: "Bollingen",
    8716: "Schmerikon",
    8717: "Benken",
    8718: "Schänis",
    8722: "Kaltbrunn",
    8723: "Rufi - Maseltrangen",
    8725: "Ernetschwil - Gebertingen",
    8726: "Ricken",
    8727: "Walde",
    8730: "Uznach",
    8732: "Neuhaus",
    8733: "Eschenbach",
    8734: "Ermenswil",
    8735: "St. Gallenkappel - Rüeterswil",
    8737: "Gommiswald",
    8738: "Uetliburg",
    8739: "Rieden",
    8750: "Riedern - Klöntal - Glarus",
    8751: "Urnerboden",
    8752: "Näfels",
    8753: "Mollis",
    8754: "Netstal",
    8755: "Ennenda",
    8756: "Mitlödi",
    8757: "Filzbach",
    8758: "Obstalden",
    8759: "Netstal",
    8762: "Schwanden - Sool - Schwändi b. Schwanden",
    8765: "Engi",
    8766: "Matt",
    8767: "Elm",
    8772: "Nidfurn",
    8773: "Haslen",
    8774: "Leuggelbach",
    8775: "Luchsingen - Hätzingen",
    8777: "Diesbach - Betschwanden",
    8782: "Rüti",
    8783: "Linthal",
    8784: "Braunwald",
    8800: "Thalwil",
    8801: "Thalwil Fächer",
    8802: "Kilchberg",
    8803: "Rüschlikon",
    8804: "Au",
    8805: "Richterswil",
    8806: "Bäch",
    8807: "Freienbach",
    8808: "Pfäffikon",
    8810: "Horgen",
    8812: "Horgen Bahnhof Oberdorf",
    8813: "Horgen",
    8815: "Horgenberg",
    8816: "Hirzel",
    8820: "Wädenswil",
    8824: "Schönenberg",
    8825: "Hütten",
    8832: "Wollerau - Wilen b. Wollerau",
    8833: "Samstagern",
    8834: "Schindellegi",
    8835: "Feusisberg",
    8836: "Bennau",
    8840: "Trachslau - Einsiedeln",
    8841: "Gross",
    8842: "Unteriberg",
    8843: "Oberiberg",
    8844: "Euthal",
    8845: "Studen",
    8846: "Willerzell",
    8847: "Egg",
    8849: "Alpthal",
    8852: "Altendorf",
    8853: "Lachen",
    8854: "Galgenen - Siebnen",
    8855: "Wangen",
    8856: "Tuggen",
    8857: "Vorderthal",
    8858: "Innerthal",
    8862: "Schübelbach",
    8863: "Buttikon",
    8864: "Reichenburg",
    8865: "Bilten",
    8866: "Ziegelbrücke",
    8867: "Niederurnen",
    8868: "Oberurnen",
    8872: "Weesen",
    8873: "Amden",
    8874: "Mühlehorn",
    8877: "Murg",
    8878: "Quinten",
    8879: "Pizolpark (Mels)",
    8880: "Walenstadt",
    8881: "Knoblisbühl - Walenstadtberg - Tscherlach",
    8882: "Unterterzen",
    8883: "Quarten",
    8884: "Oberterzen",
    8885: "Mols",
    8886: "Mädris-Vermol",
    8887: "Mels",
    8888: "Heiligkreuz (Mels)",
    8889: "Plons",
    8890: "Flums",
    8892: "Berschis",
    8893: "Flums Hochwiese",
    8894: "Flumserberg Saxli",
    8895: "Flumserberg Portels",
    8896: "Flumserberg Bergheim",
    8897: "Flumserberg Tannenheim",
    8898: "Flumserberg Tannenbodenalp",
    8901: "Urdorf",
    8902: "Urdorf",
    8903: "Birmensdorf",
    8904: "Aesch",
    8905: "Islisberg - Arni",
    8906: "Bonstetten",
    8907: "Wettswil",
    8908: "Hedingen",
    8909: "Zwillikon",
    8910: "Affoltern am Albis",
    8911: "Rifferswil",
    8912: "Obfelden",
    8913: "Ottenbach",
    8914: "Aeugstertal - Aeugst am Albis",
    8915: "Hausen am Albis",
    8916: "Jonen",
    8917: "Oberlunkhofen",
    8918: "Unterlunkhofen",
    8919: "Rottenschwil",
    8925: "Ebertswil",
    8926: "Uerzlikon - Kappel am Albis - Hauptikon",
    8932: "Mettmenstetten",
    8933: "Maschwanden",
    8934: "Knonau",
    8942: "Oberrieden",
    8951: "Fahrweid",
    8952: "Schlieren",
    8953: "Dietikon",
    8954: "Geroldswil",
    8955: "Oetwil an der Limmat",
    8956: "Killwangen",
    8957: "Spreitenbach",
    8962: "Bergdietikon",
    8964: "Rudolfstetten",
    8965: "Berikon",
    8966: "Oberwil-Lieli",
    8967: "Widen",
    9000: "St. Gallen",
    9001: "St. Gallen",
    9004: "St. Gallen",
    9006: "St. Gallen",
    9007: "St. Gallen",
    9008: "St. Gallen",
    9009: "St. Gallen",
    9010: "St. Gallen",
    9011: "St. Gallen",
    9012: "St. Gallen",
    9013: "St. Gallen",
    9014: "St. Gallen",
    9015: "St. Gallen",
    9016: "St. Gallen",
    9020: "St. Gallen",
    9022: "St. Gallen",
    9023: "St. Gallen",
    9024: "St. Gallen",
    9026: "St. Gallen K AG",
    9027: "St. Gallen",
    9028: "St. Gallen",
    9029: "St. Gallen Sonderdienste",
    9030: "Abtwil - St. Josefen",
    9032: "Engelburg",
    9033: "Untereggen",
    9034: "Eggersriet",
    9035: "Grub",
    9036: "Grub",
    9037: "Speicherschwendi",
    9038: "Rehetobel",
    9042: "Speicher",
    9043: "Trogen",
    9044: "Wald",
    9050: "Appenzell - Appenzell Eggerstanden - Appenzell Enggenhütten - Appenzell Meistersrüte - Appenzell Steinegg - Appenzell Schlatt",
    9052: "Niederteufen",
    9053: "Teufen",
    9054: "Haslen",
    9055: "Bühler",
    9056: "Gais",
    9057: "Weissbad - Wasserauen - Schwende",
    9058: "Brülisau",
    9062: "Lustmühle",
    9063: "Stein",
    9064: "Hundwil",
    9100: "Herisau",
    9101: "Herisau",
    9102: "Herisau",
    9103: "Schwellbrunn",
    9104: "Waldstatt",
    9105: "Schönengrund",
    9107: "Urnäsch",
    9108: "Gonten - Gontenbad - Jakobsbad",
    9112: "Schachen b. Herisau",
    9113: "Degersheim",
    9114: "Hoffeld",
    9115: "Dicken",
    9116: "Wolfertswil",
    9122: "Mogelsberg - Ebersol",
    9123: "Nassen",
    9125: "Brunnadern",
    9126: "Necker",
    9127: "St. Peterzell",
    9200: "Gossau",
    9201: "Gossau",
    9203: "Niederwil",
    9204: "Andwil",
    9205: "Waldkirch",
    9212: "Arnegg",
    9213: "Hauptwil",
    9214: "Kradolf",
    9215: "Schönenberg an der Thur - Buhwil",
    9216: "Hohentannen - Heldswil",
    9217: "Neukirch an der Thur",
    9220: "Bischofszell",
    9223: "Halden - Schweizersholz",
    9225: "St. Pelagiberg - Wilen (Gottshaus)",
    9230: "Flawil",
    9231: "Egg (Flawil)",
    9240: "Niederglatt - Uzwil",
    9242: "Oberuzwil",
    9243: "Jonschwil",
    9244: "Niederuzwil",
    9245: "Sonnental - Oberbüren",
    9246: "Niederbüren",
    9247: "Henau",
    9248: "Bichwil",
    9249: "Oberstetten - Niederstetten - Algetshausen",
    9300: "Wittenbach",
    9301: "Wittenbach",
    9304: "Bernhardzell",
    9305: "Berg",
    9306: "Freidorf",
    9308: "Lömmenschwil",
    9312: "Häggenschwil",
    9313: "Muolen",
    9314: "Steinebrunn",
    9315: "Winden - Neukirch (Egnach)",
    9320: "Stachen - Arbon - Frasnacht",
    9322: "Egnach",
    9323: "Steinach",
    9325: "Roggwil",
    9326: "Horn",
    9327: "Tübach",
    9400: "Rorschach",
    9401: "Rorschach",
    9402: "Mörschwil",
    9403: "Goldach",
    9404: "Rorschacherberg",
    9405: "Wienacht-Tobel",
    9410: "Heiden",
    9411: "Reute",
    9413: "Oberegg",
    9414: "Schachen b. Reute",
    9422: "Staad",
    9423: "Altenrhein",
    9424: "Rheineck",
    9425: "Thal",
    9426: "Lutzenberg",
    9427: "Wolfhalden",
    9428: "Walzenhausen",
    9430: "St. Margrethen",
    9434: "Au",
    9435: "Heerbrugg",
    9436: "Balgach",
    9437: "Marbach",
    9442: "Büriswilen - Berneck",
    9443: "Widnau",
    9444: "Diepoldsau",
    9445: "Rebstein",
    9450: "Altstätten - Lüchingen",
    9451: "Kriessern",
    9452: "Hinterforst",
    9453: "Eichberg",
    9462: "Montlingen",
    9463: "Oberriet",
    9464: "Rüthi (Rheintal) - Lienz",
    9465: "Salez",
    9466: "Sennwald",
    9467: "Frümsen",
    9468: "Sax",
    9469: "Haag (Rheintal)",
    9470: "Werdenberg - Buchs",
    9471: "Buchs",
    9472: "Grabserberg - Grabs",
    9473: "Gams",
    9475: "Sevelen",
    9476: "Fontnas - Weite",
    9477: "Trübbach",
    9478: "Azmoos",
    9479: "Malans - Oberschan - Gretschins",
    9500: "Wil",
    9501: "Wil",
    9502: "Braunau",
    9503: "Stehrenberg - Lanterswil",
    9504: "Friltschen",
    9506: "Lommis",
    9507: "Stettfurt",
    9508: "Weingarten-Kalthäusern",
    9512: "Rossrüti",
    9514: "Wuppenau",
    9515: "Hosenruck",
    9517: "Mettlen",
    9523: "Züberwangen",
    9524: "Zuzwil",
    9525: "Lenggenwil",
    9526: "Zuckenriet",
    9527: "Niederhelfenschwil",
    9532: "Rickenbach b. Wil",
    9533: "Dietschwil - Kirchberg",
    9534: "Gähwil",
    9535: "Wilen b. Wil",
    9536: "Schwarzenbach",
    9542: "Münchwilen",
    9543: "St. Margarethen",
    9545: "Wängi",
    9546: "Tuttwil",
    9547: "Wittenwil",
    9548: "Matzingen",
    9552: "Bronschhofen",
    9553: "Bettwiesen",
    9554: "Tägerschen",
    9555: "Tobel",
    9556: "Affeltrangen - Zezikon",
    9562: "Buch b. Märwil - Märwil",
    9565: "Bussnang - Oppikon - Oberbussnang - Rothenhausen - Schmidshof",
    9573: "Littenheid",
    9601: "Lütisburg Station",
    9602: "Müselbach - Bazenheid",
    9604: "Lütisburg - Oberrindal - Unterrindal",
    9606: "Bütschwil",
    9607: "Mosnang",
    9608: "Ganterschwil",
    9612: "Dreien",
    9613: "Mühlrüti",
    9614: "Libingen",
    9615: "Dietfurt",
    9620: "Lichtensteig",
    9621: "Oberhelfenschwil",
    9622: "Krinau",
    9630: "Wattwil",
    9631: "Ulisbach",
    9633: "Hemberg - Bächli (Hemberg)",
    9642: "Ebnat-Kappel",
    9643: "Krummenau",
    9650: "Nesslau",
    9651: "Ennetbühl",
    9652: "Neu St. Johann",
    9655: "Stein",
    9656: "Alt St. Johann",
    9657: "Unterwasser",
    9658: "Wildhaus"
}